import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
import CountdownTimer from "../Component/CountdownTimer";
import React, { useEffect, useState } from "react";
import MUN2026 from "./SxMUN/MUN2026";

const SxmunInformation = () => {
  {
    /* const targetDate = new Date('2024-08-23'); */
  }
  return (
    <>
      <Header />
      <div className="inner_slider">
        <LazyLoad>
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/inner_slider.jpg"
            className="img-fluid inner_slider_img"
            alt="St. Xaviers Bathinda"
          />{" "}
        </LazyLoad>
        <div className="row bread_cumb">
          <h2>SXMUN</h2>
          <div className="theme-heading">
            <span className="colorW marB10">
              <i className="bi bi-building"></i>
            </span>
          </div>
          <h5>
            <Link to="/">
              Home <i className="bi bi-arrow-right"></i>{" "}
            </Link>
            <span>
              {" "}
              Events <i className="bi bi-arrow-right"></i>
            </span>{" "}
            <span> SXMUN </span>
            <i className="bi bi-arrow-right"></i> <span> Information </span>
          </h5>
        </div>
      </div>
      <div className="innerpage">
        <div className="inner_cont SXMUN">
          <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="pills-year26-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-year26"
                type="button"
                role="tab"
                aria-controls="pills-year26"
                aria-selected="true"
              >
                2026-27{" "}
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="pills-year25-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-year25"
                type="button"
                role="tab"
                aria-controls="pills-year25"
                aria-selected="true"
              >
                2025-26{" "}
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link "
                id="pills-year24-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-year24"
                type="button"
                role="tab"
                aria-controls="pills-year24"
                aria-selected="true"
              >
                2024-25{" "}
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="pills-year23-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-year23"
                type="button"
                role="tab"
                aria-controls="pills-year23"
                aria-selected="true"
              >
                2023-24{" "}
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="pills-home-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-home"
                type="button"
                role="tab"
                aria-controls="pills-home"
                aria-selected="true"
              >
                2022-23
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="pills-profile-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-profile"
                type="button"
                role="tab"
                aria-controls="pills-profile"
                aria-selected="false"
              >
                2021-22
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="pills-contact-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-contact"
                type="button"
                role="tab"
                aria-controls="pills-contact"
                aria-selected="false"
              >
                2020-21
              </button>
            </li>
          </ul>

          <div className="tab-content" id="pills-tabContent">

            {/* 2026-27 data */}
            <div
              className="tab-pane fade show active"
              id="pills-year26"
              role="tabpanel"
              aria-labelledby="pills-year26-tab"
            >
              <center>
                <CountdownTimer />
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN-2026-27.jpeg"
                    alt="St. Xavier’s School Bathinda"
                    className="img-fluid"
                    width="800px"
                  />
                </LazyLoad>
              </center>
              <MUN2026></MUN2026>
            </div>



    {/* 2025-26 data */}

            <div
              className="tab-pane fade"
              id="pills-year25"
              role="tabpanel"
              aria-labelledby="pills-year25-tab"
            >
              <center>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN-2025-26.jpg"
                    alt="St. Xavier’s School Bathinda"
                    className="img-fluid"
                    width="800px"
                  />
                </LazyLoad>
              </center>
              <div class="col-12 row">
                <div class="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Amaro-Martins.jpg"
                        alt="St. Xavier’s School Bathinda"
                        class="sxumn_2021_msg img-fluid"
                      />
                    </LazyLoad>
                    <h3>Rev. Fr. Manager's Message</h3>
                    <p>
                      <b>Dear Esteemed Guests, </b>
                    </p>
                    <p>
                      On behalf of the entire St. Xavier’s community, it is my
                      pleasure and honour to extend a warm and heartfelt welcome
                      to each of you as we commence this year’s eagerly awaited
                      SXMUN convention.{" "}
                    </p>
                    <p>
                      This year marks a significant chapter in our SXMUN journey
                      as we proudly open our doors to a wider global community
                      by inviting foreign delegates and welcoming participants
                      from diverse backgrounds. I am gladdened to see that our
                      platform continues to grow more inclusive by actively
                      embracing differently abled students too. Your voices and
                      perspectives will certainly exemplify the true spirit of
                      global understanding.{" "}
                    </p>
                    <p>
                      Our theme, “ECHO: Voracious, Vociferous, Vehement Call for
                      Peace,” compels us to reflect deeply on the power of
                      voices and the silences we often overlook. While the
                      echoes of pain, hunger, poverty and injustice may go
                      unheard in the noise of our daily lives, it is incumbent
                      upon us as global citizens and leaders of tomorrow to pay
                      heed to these urgent issues. Let us ensure that our
                      deliberations echo into the world as a call for peace,
                      equity and compassion.{" "}
                    </p>
                    <p>
                      I wish all delegates a fruitful and inspiring
                      conference.{" "}
                    </p>
                    <p>
                      <b>With warm regards,</b>{" "}
                    </p>
                    <p>
                      {" "}
                      Fr. Amaro Martins
                      <br />
                      (Manager){" "}
                    </p>
                    <div class="clr"></div>
                  </article>
                  <div class="clr"></div>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2023-principal.JPG"
                        alt="St. Xavier’s School Bathinda"
                        class="sxumn_2021_msg img-fluid"
                      />
                    </LazyLoad>
                    <h3>Rev. Fr. Principal's Message</h3>
                    <p>Dear Eminent Delegates,</p>
                    <p>
                      It is my honour and delight to extend the warmest welcome
                      to each one of you as we proceed with this year’s 9th
                      Edition of SXMUN conference. Your presence here is not
                      merely by chance rather it is driven by intellect, empathy
                      and a commitment to global dialogue.{" "}
                    </p>
                    <p>
                      The Theme for SXMUN 9th Edition ‘Echoes’ shall vehemently
                      focus on the world that is echoing not with words but with
                      wounds- pleas for peace ringing from the ruins of war.
                      Every border crossed in blood, every bomb that falls and
                      every silence after gunfire becomes part of a deafening
                      global echo: ‘It is Enough.’ Today, the world is no longer
                      whispering, it is roaring with anguish, with cries for
                      justice, for dignity and for the restoration of humanity
                      that seems to have existed in the past. Currently, in
                      every refugee’s footsteps, in every orphan’s tears, there
                      is an echo that is yearning not for revenge but for
                      refuge, for reason and most importantly for
                      reconciliation. What is the world echoing for? Not more
                      treaties penned in silence but action through empathy and
                      enduring peace.{" "}
                    </p>
                    <p>
                      This year, we take a step forward in our mission to create
                      a world we envision. For the first time, we proudly
                      welcome international delegates to our SXMUN. Equally
                      significant is our commitment to inclusivity. We are proud
                      to actively integrate differently abled students into the
                      very heart of this MUN experience. Your presence shall
                      certainly broaden our horizons.
                    </p>
                    <p>
                      As delegates, your role here is critical. You are not just
                      simulating diplomacy rather you are acquiring the training
                      to become the leaders who will intensify these echoes into
                      roars that will shake the foundations of apathy. Hence, I
                      recommend you to engage vigorously, listen empathetically
                      and collaborate respectfully.{" "}
                    </p>
                    <p>
                      Our dedicated faculty, staff and the SXMUN Secretariat are
                      always there to support you. Please reach out and make
                      connections that will last far beyond this
                      conference.{" "}
                    </p>
                    <p>
                      <strong>
                        Anticipating confidence in your abilities and vision, I
                        extend my best wishes to all of you.{" "}
                      </strong>
                      <br />
                      Fr. Cidloy Furtado <br />
                      (Principal){" "}
                    </p>
                    <div class="clr"></div>
                  </article>
                  <div class="clr"></div>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <h3>Secretary General's Message</h3>
                    <p>
                      {" "}
                      “When the power of love overcomes the love of power, the
                      world will know peace.” — <b>Jimi Hendrix</b>{" "}
                    </p>{" "}
                    <p> Greetings everyone, </p>{" "}
                    <p>
                      {" "}
                      We live in an era where hatred is louder than reason and
                      silence often walks hand in hand with complicity. The
                      world doesn’t need another war. What it needs is a
                      generation that isn’t afraid to speak, to question and to
                      act.{" "}
                    </p>{" "}
                    <p>
                      {" "}
                      This year, the theme of SXMUN is more than just a phrase —
                      it's a reflection of our times and a challenge to our
                      conscience: ECHOES: A Voracious, Vociferous, Vehement Call
                      for Peace. Peace today must be more than a diplomatic
                      ideal. It must be a demand. Voracious, because we must
                      hunger for truth and justice in an age of misinformation.
                      Vociferous, because silence has never protected the
                      oppressed. Vehement, because our belief in peace should be
                      fierce, not fragile.{" "}
                    </p>{" "}
                    <p>
                      {" "}
                      Since its inception in 2017, St. Xavier’s Model United
                      Nations has stood as a space for students to think
                      critically and feel deeply. SXMUN 2025 continues that
                      legacy — now more urgent than ever. We are not just
                      delegates in a committee room; we are the inheritors of a
                      world in crisis and the architects of what comes
                      next.{" "}
                    </p>{" "}
                    <p>
                      {" "}
                      We will debate, we will dissent and we will disagree but
                      through that, we will grow. because peace isn't passive.
                      It’s built word by word, choice by choice. Let SXMUN be a
                      space where empathy meets action, where opinions turn into
                      purpose and where we echo not the noise of division
                      but{" "}
                    </p>{" "}
                    <p> the sound of hope. </p>{" "}
                    <p>
                      {" "}
                      The time to wait is over. The time to speak is now. Let
                      the echoes begin.{" "}
                    </p>
                    <p>
                      <strong> Warm Regards,</strong>
                      <br />
                      Harshmeet Sarwara <br />
                      (Secretary General, SXMUN'25){" "}
                    </p>
                    <div class="clr"></div>
                  </article>
                  <div class="clr"></div>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <h3>Director General's Message</h3>
                    <p>
                      “Peace cannot be kept by force; it can only be achieved by
                      understanding.” <b>– Albert Einstein</b>{" "}
                    </p>{" "}
                    <p>
                      {" "}
                      <b>Dear Delegates,</b>{" "}
                    </p>{" "}
                    <p>
                      It gives me great pleasure to welcome you to this year’s
                      edition of St. Xavier’s Model United Nations, where we
                      gather under a theme that is bold, intense and deeply
                      meaningful: ECHOES – Voracious, Vociferous, Vehement: A
                      Call for Peace.{" "}
                    </p>{" "}
                    <p>
                      In today’s world, where conflicts dominate headlines and
                      polarization grows every day, peace often feels like a
                      distant dream. But peace isn’t passive. It’s not the
                      silence after war — it is the active pursuit of justice,
                      dialogue and understanding. That’s what this year’s theme
                      is all about.{" "}
                    </p>{" "}
                    <p>
                      To be voracious means having a strong desire — a hunger
                      for change. As young leaders and future diplomats, your
                      desire for peace must be more than an idea. It must be a
                      driving force behind every word you speak and every
                      solution you offer.{" "}
                    </p>{" "}
                    <p>
                      To be vociferous means being bold in speech — not afraid
                      to raise your voice for those who can’t. In committee, you
                      must speak with purpose, stand up for your beliefs and
                      give space to voices that are often ignored in global
                      discussions.{" "}
                    </p>{" "}
                    <p>
                      To be vehement means to believe in something with passion
                      and emotion. Your presence here isn’t just for debate —
                      it’s for impact. Let your resolutions carry the weight of
                      real empathy, real urgency, and a real will to build
                      peace.{" "}
                    </p>{" "}
                    <p>
                      This conference is offers growth, awareness and
                      empowerment. The problems you’re discussing are real. The
                      voices you represent are real. And the skills you’re
                      building are what the world desperately needs — the
                      ability to listen, to lead and to build peace even in
                      disagreement.{" "}
                    </p>{" "}
                    <p>
                      Let your voices echo beyond these rooms. Let your ideas
                      challenge the norm. And above all, let your actions
                      reflect the kind of world you wish to live in.{" "}
                    </p>{" "}
                    <p>
                      Wishing you all a meaningful, impactful and empowering MUN
                      experience.
                    </p>
                    <p>
                      <strong>Regards </strong>
                      <br />
                      Himankshi Gupta <br />
                      (Director General, SXMUN'25)
                    </p>
                    <div class="clr"></div>
                  </article>
                  <div class="clr"></div>
                </div>
              </div>

              <div className="sxmun_img_sec_new row">
                <center>
                  <h2>Committees and Agendas for SXMUN 2025 </h2>
                </center>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN25-1.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN25-2.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN25-3.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN25-4.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN25-5.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN25-6.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4 mx-auto d-block">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN25-7.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4 mx-auto d-block">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN25-8.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 col-12 sx_msg_sec">
                <article>
                  <p>
                    Jashan is an entrepreneur who in 2021 launched MNMLST and
                    has been building that ever since. When not working on
                    MNMLST, he spends his time on NBA, F1, reading and
                    travelling.{" "}
                  </p>
                  <p>
                    Jashan Guliani <br />{" "}
                  </p>

                  <div className="clr"></div>
                </article>

                <article>
                  <p>
                    At just 18, Kabir Sethi is a dynamic entrepreneur and a
                    leading figure in the Model United Nations circuit. With
                    over 50 conferences under his belt as a Delegate, Executive
                    Board Member, and Secretariat, he brings unparalleled
                    expertise in diplomacy, public speaking, and committee
                    management. <br />
                    As the Founder & CEO of Kairos Learning, Kabir has empowered
                    hundreds of students across India through high-impact MUN
                    conferences, debate training modules, and leadership
                    development programs. His ventures reflect a deep commitment
                    to fostering academic excellence and youth engagement.{" "}
                    <br />
                    A professional event curator, Kabir has successfully
                    organized large-scale academic and corporate events,
                    combining precision with innovation. He is regularly invited
                    as a guest speaker and MUN trainer at prestigious
                    institutions, where he is known for mentoring young minds,
                    structuring dynamic agendas, and strengthening political
                    discourse. <br />
                    Kabir’s comprehensive understanding of parliamentary
                    procedure, international relations, and political ideologies
                    sets him apart as a trailblazer in the youth leadership
                    domain. Passionate, visionary, and impact-driven, he
                    continues to inspire the next generation of
                    change-makers.{" "}
                  </p>
                  <p>
                    {" "}
                    Kabir Sethi <br />{" "}
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <p>
                    Aaryan Wadhwa is an alumnus of St. Xavier’s School,
                    Bathinda, and holds an LLB from the University of Petroleum
                    and Energy Studies, Dehradun. With significant experience in
                    Model United Nations, he is currently working as an
                    Assistant Advocate at the High Court, bringing both legal
                    expertise and MUN knowledge to SXMUN 2025.{" "}
                  </p>
                  <p>
                    {" "}
                    Aryan Wadhwa <br />{" "}
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <p>
                    Jesus Goyal is a final-year law student at Panjab
                    University, Ludhiana, and has been an active part of the
                    debating and mooting circuit for the past 9 years. Known for
                    his confident speaking and sharp arguments, he has secured
                    top positions at national-level Moot Court and Model UN
                    competitions. Currently serving as the President of Panjab
                    University, Ludhiana, he’s committed to helping others grow
                    into stronger debaters and more confident individuals.{" "}
                  </p>
                  <p>
                    {" "}
                    Jesus <br />{" "}
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <p>
                    Yatish Chawla is a Bachelor of Commerce student at Kirori
                    Mal College, University of Delhi, building a strong
                    foundation in business and financial strategy. An alumnus of
                    St. Xavier’s School, Bathinda, he has consistently shown
                    academic excellence and leadership. With five years of MUN
                    experience—as a delegate, executive board member,
                    consultant, and secretariat—he has developed sharp
                    analytical and organizational skills. His internships at
                    Dublieu (HR) and Aashray NGO (marketing) have further
                    strengthened his professional acumen. Yatish is known for
                    his thoughtful approach, commitment to excellence, and drive
                    to make a meaningful impact.{" "}
                  </p>
                  <p>
                    {" "}
                    Yatish <br />{" "}
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <p>
                    Sukriti Mittal is an alumna of St. Xavier's School, Bathinda
                    and is currently a first-year law student. She possesses a
                    strong interest in geopolitics and debating. In addition to
                    her academic pursuits, she has a passion for reading and
                    enjoys exploring the nuances of poetry. During her time in
                    school, she held several esteemed positions, including
                    Director General of SXMUN'24 and English Editor of the
                    school parliament, showcasing her leadership skills and
                    dedication to fostering a vibrant academic community.{" "}
                  </p>
                  <p>
                    {" "}
                    Sukriti <br />{" "}
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <p>
                    Kushagra Gulyani is a 19-year-old dedicated student
                    currently pursuing Chartered Accountancy alongside B.Com
                    from Delhi University. With diverse experience of three
                    years MUNs and Youth Parliaments, he brings a wealth of
                    knowledge, confidence, and composure to every committee.
                    Known for his excellent communication skills and dynamic
                    personality, Kushagra is committed to ensuring a structured,
                    engaging, and enriching MUN experience for all.{" "}
                  </p>
                  <p>
                    {" "}
                    Kushagra Gulyani <br />{" "}
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <p>
                    *Cheshta Dabra, is a graduate from the University of Delhi,
                    Indraprastha College for Women, with a strong passion for
                    training young minds and helping children find their voice.
                    Since 2018, she’s been actively involved in Model United
                    Nations—starting with organizing conferences, and later
                    chairing and judging over 20 plus MUNs and panel
                    discussions, especially on women empowerment. She has
                    proudly represented her college at platforms like the **G20
                    India Conclave* and as an *Apprentice under the UN Academic
                    Impact – Millennium Campus Network. Currently, she’s working
                    with the **Central Marketing Team at HDFC Life*, continuing
                    to channel her love for communication, leadership, and youth
                    empowerment.{" "}
                  </p>
                  <p>
                    {" "}
                    Cheshta Dabra <br />{" "}
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <p>
                    Zafroz Singh Dandiwal is an avid debater, competitive skeet
                    shooter, and skilled polo player with a passion for
                    leadership and diplomacy. An alumnus of Woodstock School,
                    Mussoorie—one of India’s premier international
                    institutions—he has earned recognition for his articulate
                    public speaking and strategic thinking in national and
                    international Model United Nations conferences. Zafroz is
                    currently pursuing his undergraduate studies at nmims
                    University, where he continues to build on his diverse
                    interests in global affairs, sportsmanship, and law.{" "}
                  </p>
                  <p>
                    {" "}
                    Zafroz Singh Dandiwal <br />{" "}
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <p>
                    Ansh Sharma, a distinguished student leader, has been making
                    waves at Delhi Public School, Bathinda. As the Vice Head Boy
                    in 2024 and currently the Head of Cultural Affairs, Ansh has
                    consistently demonstrated exceptional leadership skills.
                    With over 25 Model United Nations (MUN) conferences under
                    his belt, he has refined his expertise in diplomacy, debate,
                    and global affairs. Ansh has held pivotal roles, including
                    Secretariat, Executive Board Member, and Director General of
                    CONSORTIUM, where he served as Secretary General in 2024,
                    fostering inclusive and dynamic environments for productive
                    dialogue. Ansh's achievements extend beyond MUNs. He has
                    been awarded the Bronze Medal by the International Award for
                    Young People (IAYP), recognizing his dedication to community
                    service and personal growth. His participation in AFS
                    Intercultural Programs has broadened his perspectives on
                    global understanding, intercultural learning, and
                    leadership. Through his passion for social work and
                    commitment to positive impact, Ansh continues to inspire his
                    peers and community. His impressive track record showcases
                    his potential as a future leader, driven by a strong work
                    ethic and a vision for a better world.{" "}
                  </p>

                  <p>
                    {" "}
                    Ansh Sharma <br />{" "}
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <p>
                    A law student at Campus Law Centre, University of Delhi,
                    with a strong interest in Human Rights and International
                    Law. I have a passion for debating, with over eight years of
                    experience, and have participated in more than 100 MUNs and
                    Youth Parliament Conferences across educational institutions
                    in India. In addition to being an avid MUNner and a public
                    speaking coach, I am the Founder of the Association for
                    Social Activities and Reforms (ASAR)— an organization
                    dedicated to nurturing essential soft skills in youth, such
                    as research, critical thinking, public speaking, and
                    teamwork. Through mentorship programs and internships, ASAR
                    aims to empower young individuals and help build a better
                    future for the next generation.{" "}
                  </p>
                  <p>
                    {" "}
                    Aditya Wadhwa <br />{" "}
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <p>
                    “Unshaken faith and quiet grind outlast every doubt.” Amanat
                    Brar, alumna of St. Xavier’s, Bathinda, has served as Prime
                    Minister, Head Girl, Secretary-General of SXMUN 2023, and
                    Chief of Staff in 2022. A passionate debater, experienced
                    MUN delegate, and confident public speaker, she is currently
                    pursuing a Bachelor’s in Business Administration while
                    preparing for competitive exams. Her creative side comes
                    alive through sketching, reflecting a balance of ambition
                    and expression. Her journey so far has been shaped less by
                    the titles held and more by the intent behind them—a quiet
                    commitment to growth, and a belief that real impact often
                    speaks for itself.{" "}
                  </p>
                  <p>
                    {" "}
                    Amanat brar <br />{" "}
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <p>
                    Meet Dhillon is the visionary Founder of Epoch MUN, a
                    platform born from his unwavering commitment to innovation
                    in youth diplomacy. Since 2018, he has chaired Model United
                    Nations committees pan India guiding spirited debates on
                    global health, climate change, human rights, and
                    international security with an emphasis on collaboration and
                    critical thinking. Beyond presiding over these sessions,
                    Meet has spearheaded the organization of five flagship
                    conferences across India, overseeing everything from
                    sponsorship negotiations and committee design to logistical
                    coordination.{" "}
                  </p>
                  <p>
                    {" "}
                    Meet Dhillon <br />{" "}
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <p>
                    Sanjana is currently working with the global consultancy
                    firm Ernst & Young, while also pursuing her ambition of
                    becoming a Chartered Accountant — a journey that continues
                    to inspire many. With a strong foundation in international
                    taxation and extensive experience in the MUN circuit, she
                    has played a pivotal role in organizing conferences and
                    mentoring delegates as they explore pressing global issues.
                    Having once walked the same halls, this conference is
                    especially meaningful to her. Her dedication to fostering a
                    collaborative and intellectually enriching environment is
                    truly commendable. She is passionate about empowering
                    students to build skills in diplomacy, critical thinking,
                    and leadership. Sanjana firmly believes that SXMUN 2025 is
                    poised to create a new chapter in the history of Model
                    United Nations — and we couldn’t agree more.{" "}
                  </p>
                  <p>
                    {" "}
                    Sanjana Singla <br />{" "}
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <p>
                    Lovisha is a dynamic individual who has traversed a diverse
                    professional landscape following her completion of a
                    bachelor's degree in global studies. With a multifaceted
                    career path, she has seamlessly transitioned between roles
                    as a trainer, manager, mentor, and content researcher in
                    Implementors, each experience adding layers to her
                    expertise. For the past seven years, she has been honing her
                    teaching skills under the tutelage of Mr. Menon, a seasoned
                    educator, imbuing her with a wealth of knowledge and
                    pedagogical finesse. Particularly adept at preparing
                    students for challenging assessments such as CDS exams and
                    SSB interviews,{" "}
                  </p>
                  <p>
                    {" "}
                    Lovisha <br />{" "}
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <p>
                    Allamveer Dhillon is a dynamic and well-rounded individual
                    with a strong passion for Model United Nations. With
                    extensive experience in national and international MUN
                    conferences, he is known for his sharp diplomacy, persuasive
                    communication, and ability to lead meaningful dialogue on
                    global issues. <br />
                    He is equally passionate about media and communication,
                    using platforms like public speaking and content creation to
                    inspire thought and engagement. A dedicated football player
                    and NCC cadet, Allam veer values discipline, teamwork, and
                    leadership. His artistic pursuits further reflect his
                    creative mindset and unique perspective. <br />
                    Driven, articulate, and versatile, he continues to make his
                    mark across diverse fields with confidence and purpose.{" "}
                  </p>
                  <p>
                    {" "}
                    Allamveer Dhillon <br />{" "}
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <p>
                    Evereena is currently pursuing her degree of B.A. LL.B. at
                    the prestigious Panjab University, Chandigarh. She has been
                    associated with SXMUN since 2019 and has proven to be an
                    asset to it through her knack of proficiency. One can find
                    her deeply engaged in conversations of gender equality and
                    sensitization over a cup of tea. She tries to keep abreast
                    of the recent events and engages in forums and dialogues to
                    give voice to her thoughts.{" "}
                  </p>
                  <p>
                    {" "}
                    Evreena <br />{" "}
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <p>
                    Anahad Cheema is an alumnus of St. Xavier's School, Bathinda
                    and is currently pursuing her degree of B.Com. LL.B in
                    Panjab University, Chandigarh. She has been an integral part
                    of the MUN circuit for over 5 years and has acquired many
                    prestigious accolades since. She has served as the Secretary
                    general for SXMUN24 as well. She enjoys classic and feminist
                    literature and lives by Mary Shelley's words- "I do not wish
                    women to have power over men; but over themselves".{" "}
                  </p>
                  <p>
                    {" "}
                    Anahad <br />{" "}
                  </p>

                  <div className="clr"></div>
                </article>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 col-12 sx_msg_sec">
                <center>
                  <h2>THE SECRETARIAT</h2>
                </center>
                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/KabirSethi-25.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>
                  <p>
                    An 18-year-old dynamic entrepreneur, I bring unmatched
                    experience and leadership to SXMUN 2025 as its Chief
                    Advisor. With an impressive portfolio of 50+ Model United
                    Nations conferences as a Delegate, Executive Board Member
                    and Secretariat, I have mastered the art of diplomacy,
                    public speaking and committee management. I am the Founder &
                    CEO of Kairos Learning, a platform dedicated to promoting
                    debate culture and academic excellence through MUN
                    conferences and training programs. I am a professional event
                    organizer, having successfully planned and executed
                    large-scale academic and corporate events with precision and
                    creativity. Recognized for my exceptional ability to guide
                    committees, design impactful agendas and mentor
                    participants, I have been invited as a guest speaker and
                    trainer at several reputed institutions. My expertise spans
                    political frameworks, parliamentary procedures and youth
                    leadership development, making me an ideal Chief Advisor for
                    SXMUN 2025. Passionate, innovative and results-driven, I
                    stand as a role model for young leaders, blending
                    entrepreneurial vision with a deep commitment to empowering
                    the global youth community.
                  </p>
                  <p>
                    {" "}
                    Kabir Sethi <br />– Chief Advisor{" "}
                  </p>

                  <div className="clr"></div>
                </article>

                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/HarshmeetSarwara.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>
                  <p>
                    As Secretary General, I believe in leading with clarity,
                    conviction, and collaboration. I aim to create a space where
                    ideas flow freely, teams work with purpose and every
                    initiative reflects the effort behind it. This isn’t just
                    about running a team — it’s about setting a standard and
                    making sure we rise to it, together. My goal is simple: to
                    make sure every voice is heard, valued and reflected in the
                    work we do. My leadership is rooted in one core belief:
                    progress starts when everyone at the table feels like their
                    voice matters. I value clear communication, quiet
                    consistency and making space for others to step forward. The
                    goal isn’t just to lead well but to leave something better
                    behind. We move forward when everyone feels seen. I believe
                    a strong team isn’t built by one person speaking but by many
                    being heard. “The loudest room isn’t always the one that
                    gets the most done—it’s the one where people actually
                    listen.” I extend my warm welcome to all of you and am
                    looking forward to a cherishing experience at the 9th
                    Edition of St. Xavier’s Model United Nations.
                  </p>
                  <p>
                    Harshmeet Sarwara <br />{" "}
                  </p>

                  <div className="clr"></div>
                </article>

                <article>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/HimankshiGupta.jpg"
                    alt="St. Xavier’s School Bathinda"
                    className="sxumn_2021_msg_secr"
                  />
                  <p>
                    It is with immense pride and deep responsibility that I step
                    into the role of Director General for SXMUN 2025. This
                    journey is more than just an event - it is a movement, a
                    platform where passion meets purpose, where young minds come
                    together to debate, deliberate and design a better tomorrow.
                    SXMUN has always been a melting pot of ideas, cultures and
                    change-makers. As we prepare to write the next chapter, I am
                    committed to ensuring that every opinion is taken seriously,
                    every delegate feels empowered and every committee resonates
                    with diplomacy, intellect and innovation. To lead is not
                    merely to instruct -it is to listen, to inspire and to build
                    something far greater than oneself. Together, with an
                    exceptional Secretariat and an unwavering vision, SXMUN 2025
                    will not just be a simulation, but a celebration of
                    leadership, global consciousness and action.
                  </p>
                  <p>
                    Himankshi Gupta <br />{" "}
                  </p>
                  <div className="clr"></div>
                </article>

                <article>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/TrigunKaurDhillon.jpg"
                    alt="St. Xavier’s School Bathinda"
                    className="sxumn_2021_msg_secr"
                  />
                  <p>
                    "When they aim to rattle your spirit, let your silence echo
                    louder than their noise, nothing bruises egos more than
                    being ignored by the one they can’t shake."I'm Trigun Kaur
                    Dhillon, the Convenor for SXMUN 2025.From the Speaker of the
                    School Parliament 2024-25 , USG in SXMUN 24 and now holding
                    the title of 'Charge D'Affaires' in 'Fateh MUN 2025, My
                    journey has been a blend of hardships and unforgettable
                    memories, I started my 11th-grade at St. Xavier’s last year
                    (as an new student ) it's been a calm rollercoaster (yes,
                    that paradox is real). More highs than lows, but each turn
                    taught me something new. Event management and MUNs aren’t
                    just a hobby they seem like a rationale. Whether it's
                    drafting excel sheets or sparking conversations in teams, I
                    live for the moments that bring people together. A social
                    soul who loves bikes and priceless possessions because at
                    the end of the day, it’s the bonds we build and the
                    substance that we preserve with love that matters the most.
                    Personally gym feels like it's the most productive and
                    emotionally de-stressing, I have all the so called
                    stereotypical made for men hobbies in me which I'm proud of.
                    I love my life, I love my friends more than anything
                    basically my friends are my one and only family. St.
                    Xavier’s has not only given me a platform but a perspective.
                    a vision for which I’ll forever be indebted. So here I stand
                    not just as the Convenor but as a reflection of everything
                    I’ve learned, loved and led so far. And trust me, my journey
                    has just begun... I assure each one of you that this event
                    would leave a positive indelible print in your mind.
                  </p>
                  <p>
                    {" "}
                    Trigun Kaur Dhillon <br />{" "}
                  </p>
                  <div className="clr"></div>
                </article>

                <article>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/ParthGarg.jpg"
                    alt="St. Xavier’s School Bathinda"
                    className="sxumn_2021_msg_secr"
                  />
                  <p>
                    I’m Parth Garg, a Grade 10 student at St. Xavier’s School,
                    Bathinda and I currently serve as the Chargé d’Affaires for
                    SXMUN 2024. With experience in over 15 MUNs and a long list
                    of awards, I bring both dedication and diplomacy to every
                    role I take on. My journey in MUNs began right here at SXMUN
                    and has since grown into a strong passion for global
                    affairs, negotiation and youth leadership. To me, MUNs are
                    more than just debates — they’re platforms to learn,
                    connect, and grow. Outside of committee sessions, I’m also a
                    creative graphic designer. I use my skills to craft engaging
                    visuals and enhance delegate experiences across events. This
                    passion has even allowed me to start earning independently
                    at a young age - proof that when effort meets purpose,
                    opportunities follow. As Chargé d’Affaires, I play a key
                    role in building strong communication between the delegates
                    and the Secretariat. My focus is on ensuring every delegate
                    feels involved, supported and inspired throughout their
                    SXMUN journey. I look forward to welcoming you to SXMUN 2024
                    - a conference where we embrace challenges, empower ideas
                    and enhance global understanding together.
                  </p>
                  <p>
                    Parth Garg <br />{" "}
                  </p>
                  <div className="clr"></div>
                </article>

                <article>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/TeghpartapSingh.jpg"
                    alt="St. Xavier’s School Bathinda"
                    className="sxumn_2021_msg_secr"
                  />
                  <p>
                    As the Co-Convener of SxMUN 2025, I’ve had the privilege of
                    working alongside an incredible team to bring this
                    conference to life. Having been a delegate myself not too
                    long ago, I understand how impactful a well-organized MUN
                    can be- not just in honing debate skills but in shaping
                    perspectives on global issues. At SxMUN 2025, we’ve strived
                    to create a platform where every delegate gets motivated and
                    inspired. From intense committee sessions to late-night
                    strategy talks, this conference is designed to be an
                    unforgettable experience. It’s not just about resolutions
                    and awards but about conversations that stay with you long
                    after the gavel falls. I look forward to seeing SxMUN 2025
                    exceed every expectation.
                  </p>
                  <p>
                    Teghpartap Singh <br />{" "}
                  </p>
                  <div className="clr"></div>
                </article>

                <article>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/MayurGarg.jpg"
                    alt="St. Xavier’s School Bathinda"
                    className="sxumn_2021_msg_secr"
                  />
                  <p>
                    I am Mayur Garg, a passionate student of St. Xavier’s
                    School, Bathinda, who is Chief of Staff Of SXMUN’25 and also
                    the Deputy Prime Minister of the School Parliament. I have
                    attended a total of 8 MUN conferences, all in AIPPM,
                    representing various Political Parties and Leaders, showing
                    my Public Speaking, Negotiation and Research Skills.
                    Throughout this journey, I have earned recognition for my
                    performance, which includes 3 Verbal Mentions, 2 Honorable
                    Mentions and 1 High Commendation. Each MUN has allowed me to
                    understand National Issues, practice diplomacy and develop a
                    balanced, solution- oriented Mindset. These experiences have
                    not only helped me grow as a delegate but also strengthened
                    my confidence and critical thinking. Beyond MUNs, I am
                    deeply involved in Public Speaking, like speeches, debates
                    and leadership activities. I am also interested in Olympiads
                    like Silverzone Olympiads, IOQM, NSEP, AMC and many more. I
                    enjoy doing all these activities, where ideas and creativity
                    come together. I believe in the power of youth voices and
                    aspire to use platforms like MUNs to bring change, however
                    small it may look . I look forward to continuing this
                    journey and contributing meaningfully to every committee I
                    serve.
                  </p>
                  <p>
                    Mayur Garg <br />{" "}
                  </p>
                  <div className="clr"></div>
                </article>

                <article>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/ManyaMangla.jpg"
                    alt="St. Xavier’s School Bathinda"
                    className="sxumn_2021_msg_secr"
                  />
                  <p>
                    Communication is more than a skill; it is my passion and I
                    have fulfilled my passion after serving as a member in the
                    organising committee in the previous session. Today, I
                    experience a sense of pride as I now lead as PR head in the
                    secretariat of SXMUN 2025 <br />I am passionate about public
                    engagement, building trust through meaningful connections.
                    It’s a role that allows me to do what I enjoy most working
                    with people, sharing stories that matters and making sure
                    the right voices are heard. I aim to bring intention into
                    everything I put out making sure every voice gets the
                    platform it deserves and that the work we do is not just
                    visible but understood. For me, the real impact of this role
                    lies in making sure the spotlight doesn’t just shine—but
                    shines in the right direction. I believe that communication
                    should be clear, human and grounded in purpose. That’s the
                    standard I hold myself to, every single day.
                  </p>
                  <p>
                    {" "}
                    Manya Mangla
                    <br />{" "}
                  </p>
                  <div className="clr"></div>
                </article>

                <article>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Janvi.jpg"
                    alt="St. Xavier’s School Bathinda"
                    className="sxumn_2021_msg_secr"
                  />
                  <p>
                    With experience spanning both sides of the MUN table, I
                    bring a well-rounded perspective to SXMUN. I’ve participated
                    in two MUNs as a delegate and served once as an OC member,
                    gaining hands-on insight into both committee dynamics and
                    event execution. Previously, I served as the General
                    Secretary at my school, a role that sharpened my
                    organizational and leadership skills. Each experience taught
                    me something new - from diplomacy and research to teamwork
                    and crisis management. I love spending my time painting,
                    exploring different forms of art and getting lost in novels.
                    Whether it’s organizing logistics or diving into a good
                    book, I enjoy finding beauty in the details. Now, as the
                    Logistics Head, I’m focused on making sure every piece
                    behind the scenes runs like clockwork - from materials and
                    movement to time and team management. I enjoy organizing
                    things down to the last detail and solving problems on the
                    fly - it’s like art in motion which makes sense since I also
                    love painting and reading novels in my free time. I am sure
                    that this conference would be an incredible one for each one
                    of us.
                  </p>
                  <p>
                    {" "}
                    <br />{" "}
                  </p>
                  <div className="clr"></div>
                </article>

                <article>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/RishavJindal.jpg"
                    alt="St. Xavier’s School Bathinda"
                    className="sxumn_2021_msg_secr"
                  />
                  <p>
                    {" "}
                    <b>
                      "The journey of a thousand miles begins with a single
                      step." — Lao Tzu{" "}
                    </b>
                    <br />
                    From nervously stepping into my first MUN to now being part
                    of the Secretariat, my journey in the MUN circuit has been
                    nothing short of transformative. Over the course of 9
                    conferences, I’ve had the privilege of representing diverse
                    countries, debating on global issues, and winning multiple
                    awards but most importantly, I’ve grown as a speaker, a
                    leader and a team player. Now, as the Head of National and
                    International Delegate Affairs, I’m excited to give back to
                    the MUN community that shaped me. I’m here to ensure that
                    every delegate—whether it’s their first conference or their
                    tenth- feels supported, challenged and inspired. My goal is
                    to create meaningful connections across borders, make
                    diplomacy accessible and help delegates make the most out of
                    every committee session.
                  </p>
                  <p>
                    Rishav Jindal <br />{" "}
                  </p>
                  <div className="clr"></div>
                </article>

                <article>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/GurnaazKaur.jpg"
                    alt="St. Xavier’s School Bathinda"
                    className="sxumn_2021_msg_secr"
                  />
                  <p>
                    <b>
                      "...Our most basic common link is that we all inhabit this
                      planet. We all breathe the same air....” — John F. Kennedy
                    </b>{" "}
                    <br />
                    In a world divided by boundaries, St. Xavier’s Model United
                    Nations took the initiative to become that very common link:
                    a space where ideas, cultures and youth voices connect
                    beyond borders. It is with immense pride and gratitude that
                    I welcome you to the ninth edition of SXMUN- a conference
                    that for the first time in its history, reaches out beyond
                    our nation into the global arena. It is both an honour and a
                    privilege for me to have contributed to that vision by
                    leading the international segment of SXMUN 2025, helping
                    bring together students from across the globe for our most
                    diverse and globally representative edition yet. I, Gurnaaz
                    Kaur, a student of Class 12, have been blessed with the
                    privilege of serving as the Youth Foreign Affairs Diplomat
                    for SXMUN 2025. This year, I have been entrusted with the
                    incredible responsibility of leading the international
                    chapter of the conference: overseeing global outreach,
                    building relations with institutions across continents and
                    welcoming international delegates into the heart of SXMUN-
                    who now represent the international voice of this
                    conference. What was once a distant vision, of uniting
                    diverse youth voices under one roof of diplomacy, has come
                    to life through your presence and participation. Your
                    involvement as international delegates is what makes this
                    edition not only historic but deeply meaningful. This year’s
                    conference is more than just larger in scale; it is richer
                    in culture, versatile in dialogue and united in spirit. My
                    mission has been to ensure that every international delegate
                    is valued and heard. To have been part of SXMUN’s evolution
                    into a truly global platform is a memory I will always carry
                    with pride and gratitude. I look forward to seeing how this
                    international convergence shapes discussions, friendships
                    and futures.
                  </p>
                  <p>
                    {" "}
                    Gurnaaz Kaur
                    <br />{" "}
                  </p>
                  <div className="clr"></div>
                </article>

                <article>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SahilGrover.jpg"
                    alt="St. Xavier’s School Bathinda"
                    className="sxumn_2021_msg_secr"
                  />
                  <p>
                    Imagine a kid attending a MUN conference for the first time,
                    nervous and uncertain of what lies ahead-to what page may
                    book of life turn to. Feels familiar? That’s one of the
                    things most of the prestigious MUNers have in common . Its
                    unique how people who have so similar first experience
                    diverge to paths which may be completely different to each
                    other. Attending my first mun in 2022 served as the push I
                    needed to put myself out there among people and grow. Since
                    then, my hunger for knowledge and excellence has only grown.
                    In the process, I have attended over 15 MUNS as a delegate
                    and have published research papers in renowned journals such
                    as IJRASET. I feel honoured to be a part of SXMUN 2025 as
                    the OC Head and look forward to making this conference a
                    success and worth the price.
                  </p>
                  <p>
                    Sahil Grover <br />{" "}
                  </p>
                  <div className="clr"></div>
                </article>
              </div>
              <div className="clr20"></div>
              <h2>
                {" "}
                Background Guides <span></span>
              </h2>
              <div className="sxmun_sec_pdf">
                <div className="row">
                  <div className="col-6 col-sm-4 col-md-3 col-lg-3 fullwidth">
                    <article>
                      {" "}
                      <Link
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/UNGA-25.pdf"
                        target="_blank"
                      >
                        {" "}
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                          alt="St. Xavier’s School Bathinda"
                          className="img-fluid"
                        />
                        <h4>UNGA</h4>
                      </Link>{" "}
                    </article>
                  </div>
                  <div className="col-6 col-sm-4 col-md-3 col-lg-3 fullwidth">
                    <article>
                      {" "}
                      <Link
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/UNSC-25.pdf"
                        target="_blank"
                      >
                        {" "}
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                          alt="St. Xavier’s School Bathinda"
                          className="img-fluid"
                        />
                        <h4>UNSC</h4>
                      </Link>{" "}
                    </article>
                  </div>
                  <div className="col-6 col-sm-4 col-md-3 col-lg-3 fullwidth">
                    <article>
                      {" "}
                      <Link
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/AISM-25.pdf"
                        target="_blank"
                      >
                        {" "}
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                          alt="St. Xavier’s School Bathinda"
                          className="img-fluid"
                        />
                        <h4>AISM </h4>
                      </Link>{" "}
                    </article>
                  </div>
                  <div className="col-6 col-sm-4 col-md-3 col-lg-3 fullwidth">
                    <article>
                      {" "}
                      <Link
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/UNCSW-25.pdf"
                        target="_blank"
                      >
                        {" "}
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                          alt="St. Xavier’s School Bathinda"
                          className="img-fluid"
                        />
                        <h4>UNCSW</h4>
                      </Link>{" "}
                    </article>
                  </div>
                  <div className="col-6 col-sm-4 col-md-3 col-lg-3 fullwidth">
                    <article>
                      {" "}
                      <Link
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/UNICEF-25.pdf"
                        target="_blank"
                      >
                        {" "}
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                          alt="St. Xavier’s School Bathinda"
                          className="img-fluid"
                        />
                        <h4>UNICEF</h4>
                      </Link>{" "}
                    </article>
                  </div>
                  <div className="col-6 col-sm-4 col-md-3 col-lg-3 fullwidth">
                    <article>
                      {" "}
                      <Link
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/WB-25.pdf"
                        target="_blank"
                      >
                        {" "}
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                          alt="St. Xavier’s School Bathinda"
                          className="img-fluid"
                        />
                        <h4> WB </h4>
                      </Link>{" "}
                    </article>
                  </div>
                  <div className="col-6 col-sm-4 col-md-3 col-lg-3 fullwidth">
                    <article>
                      {" "}
                      <Link
                        to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/AIPPM-25.pdf"
                        target="_blank"
                      >
                        {" "}
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                          alt="St. Xavier’s School Bathinda"
                          className="img-fluid"
                        />
                        <h4>AIPPM</h4>
                      </Link>{" "}
                    </article>
                  </div>
                </div>
              </div>
              <div className="clr20"></div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-year24"
              role="tabpanel"
              aria-labelledby="pills-year24-tab"
            >
              {/* <Countdown targetDate={targetDate} /> */}
              <center>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN-2024-25.jpg"
                    alt="St. Xavier’s School Bathinda"
                    className="img-fluid"
                    width="800px"
                  />
                </LazyLoad>
              </center>
              <div class="col-12 row">
                <div class="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Amaro-Martins.jpg"
                        alt="St. Xavier’s School Bathinda"
                        class="sxumn_2021_msg img-fluid"
                      />
                    </LazyLoad>
                    <h3>Rev. Fr. Manager's Message</h3>
                    <p>Dear Delegates</p>
                    <p>
                      It is with great pride that I welcome all of you who have
                      taken the initiative to join this remarkable journey of
                      diplomatic engagement. SXMUN is not merely an event,
                      rather it is an opportunity where you can freely exhibit
                      your notions on various world agendas that are of utmost
                      significance and can collectively deliberate to transform
                      your arguments into reachable resolutions.{" "}
                    </p>
                    <p>
                      Today, we are facing a plethora of world issues. Poverty
                      and economic inequality are seriously aggravating while
                      conflicts between nations are a matter of great concern.
                      Hence, international cooperation has come to a standstill.
                      At this point, it becomes indispensable to pay heed to
                      such challenges and undertake responsibilities to plan out
                      strategies so as to make the world a safe haven for one
                      and all.{" "}
                    </p>
                    <p>
                      You are the young dynamics of the world who have a vision
                      and vigour to voraciously raise your voice through
                      platforms like SXMUN to ensure a future where all
                      individuals irrespective of any caste, creed, colour can
                      prosper in harmony. By uniting together with other
                      intellectuals to address these issues with determination
                      you can certainly salvage your own planet and pave the way
                      for a more sustainable future for generations to
                      come.{" "}
                    </p>
                    <p>
                      I, therefore, request you to approach this venture with a
                      sense of ingenuity and enthusiasm by embracing each
                      other’s point of views, enhancing your discussion and
                      empowering the very purpose of finding a common solution
                      to tackle each issue. As you debate, keep in mind that you
                      are demonstrating the very ideals of the United Nations to
                      propagate for peace and cooperation.{" "}
                    </p>
                    <p>
                      I am sure that this experience will help you to enhance
                      your knowledge about the complex predicaments of the world
                      and assist you to come out with meaningful outcomes.{" "}
                    </p>
                    <p>
                      We will be honoured to have you amongst us for a fruitful
                      discourse. Wish you all the very best.{" "}
                    </p>
                    <p>
                      {" "}
                      Fr. Amaro Martins
                      <br />
                      (Manager){" "}
                    </p>
                    <div class="clr"></div>
                  </article>
                  <div class="clr"></div>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2023-principal.JPG"
                        alt="St. Xavier’s School Bathinda"
                        class="sxumn_2021_msg img-fluid"
                      />
                    </LazyLoad>
                    <h3>Rev. Fr. Principal's Message</h3>
                    <p>Dear Delegates,</p>
                    <p>
                      I feel elated to welcome you all once again to be a part
                      of the 8th edition of SXMUN 2024.{" "}
                    </p>
                    <p>
                      The proactive participation of students in SXMUN for the
                      last few years has invigorated all of us with renewed
                      energy. The main focus of SXMUN all through these years
                      has been to bring together all young prodigies and provide
                      them with the privilege to unlock their utmost potential
                      in deliberating global critical issues.{" "}
                    </p>
                    <p>
                      Today the world stands in a pitiable situation. Dearth of
                      humanity is visible all around. Thousands of innocent
                      lives have been wrecked savagely and ruined to dust.
                      Expressing grief and solidarity for those dying from pangs
                      of hunger, sympathizing for the victims who dread the
                      horrors of war and piously regretting for the loss of
                      lives are not enough. The world needs to convene at some
                      common platform to re-establish what has already been
                      destroyed due to human follies so as to salvage the
                      environment, to salvage the human lives from the brutal
                      wreckage.{" "}
                    </p>
                    <p>
                      We can only expect for a safe and flourishing future if
                      our youth is appropriately nurtured as the young
                      intellectuals can only salvage what has been destructed by
                      embracing togetherness, enhancing the level of thoughts
                      and discourses and by empowering each other to face the
                      tough challenges.{" "}
                    </p>
                    <p>
                      Hence, I support and encourage your initiative for
                      exhibiting your concern for all global issues that brings
                      you to the very platform of SXMUN. I am sure that each one
                      of you would join the conference well prepared and
                      demonstrate your aptitude to the best of your
                      ability.{" "}
                    </p>
                    <p>
                      I extend my best wishes to the Executive Board,
                      Secretariat, all the delegates and staff members for
                      putting up their efforts together so that the conference
                      proceeds on an elevated trajectory and I hope that the
                      multiplicity of opinions to come up in different
                      committees on different agendas would lead to stirring up
                      of dynamic minds.{" "}
                    </p>
                    <p>
                      I pray that all the delegates would find the conference an
                      enriching one and would come up with pragmatic solutions
                      to cater world issues.{" "}
                    </p>
                    <p>
                      <strong>Wish you all the very best..</strong>
                      <br />
                      Fr. Cidloy Furtado <br />
                      (Principal){" "}
                    </p>
                    <div class="clr"></div>
                  </article>
                  <div class="clr"></div>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2024-Coordinator.jpg"
                        alt="St. Xavier’s School Bathinda"
                        class="sxumn_2021_msg img-fluid"
                      />
                    </LazyLoad>
                    <h3>Coordinator's Message (SXMUN'24)</h3>
                    <p>Greetings Delegates</p>
                    <p>
                      "The greatest threat to our planet is the belief that
                      someone else will save it." <br />
                      &nbsp;— Robert Swan
                    </p>
                    <p>
                      SXMUN has come a long way since its inception in 2017 .
                      Venturing into the 8th edition of the conference we hope
                      to provide a momentous experience to the avid debaters
                      exposing them to the complexities of rational thinking and
                      to ensure to achieve the objective of sculpting tender
                      minds into individuals who take upon themselves the
                      responsibility of enlightening the ignorant.{" "}
                    </p>
                    <p>
                      In the light of tough realities, their lies an opportunity
                      for SALVAGE. It calls upon us to not only acknowledge the
                      challenges we face in today’s time, but to actively seek
                      solutions that harness our collective strengths and
                      potentials. The dream of utopian world would not be
                      farfetched if education overpowers ignorance and unity
                      conquers division.
                      <p>
                        Together, we can Salvage what is broken, Embrace new
                        beginnings, Enhance our efforts, and Empower all to
                        build a better world.{" "}
                      </p>
                      With this theme in mind, we seek a brighter and better
                      future with the youth as its worthy stewards taking onus
                      of shaping a new world. So, let us unanimously begin to
                      put our thoughts into practice by initiating small steps
                      because small steps lead to big impacts.{" "}
                    </p>
                    <p>
                      I hope the conference witnesses transformation of young
                      and susceptible minds into highly responsible and
                      assertive leaders of tomorrow.{" "}
                    </p>
                    <p>
                      <strong>Best Wishes</strong>
                      <br /> Poonam Baghla
                      <br />
                      (SXMUN Coordinator)
                    </p>
                    <div class="clr"></div>
                  </article>
                  <div class="clr"></div>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2024-Advisor.jpg"
                        alt="St. Xavier’s School Bathinda"
                        class="sxumn_2021_msg img-fluid"
                      />
                    </LazyLoad>
                    <h3>Advisor's Message (SXMUN'24)</h3>
                    <p>
                      In the midst of devastation, there are flickers of hope,{" "}
                      <br />
                      To mend the wounds, yes there is indeed enough scope.{" "}
                      <br />
                      Can we together SALVAGE what is wrecked -with shared
                      embrace? <br />
                      Can we weave a future that’s peaceful for human race?{" "}
                    </p>
                    <p>Greetings Delegates</p>
                    <p>
                      I am delighted to extend my warm invitation to all of you
                      to join the 8th edition of SXMUN 2024 Conference to be
                      hosted on the 23rd and 24th of August, 2024.{" "}
                    </p>
                    <p>
                      Today every individual is aware about the new situations
                      of conflict, geopolitical tensions, social instability and
                      unrest all around the globe.There is more aggression and
                      deficit of trust among world leaders. The UN’s appeal to
                      the world leaders to defeat the mounting challenges seems
                      to have no impact. At this stage, its the youth who have
                      to shoulder the responsibilities of waking the world
                      powers to comprehend these challenges and SXMUN is one of
                      the most appropriate programme for such dialogues to take
                      place.
                    </p>
                    <p>
                      I urge all of you to vociferate your voice vehemently on
                      world crises, accept and rebut on critical agendas and
                      jointly come out with amicable solutions. Your voice for
                      justice and humanity will definitely not go unheard.{" "}
                    </p>
                    <p>
                      I extend my best wishes to all the delegates and look
                      forward to a flawless plenary session ahead.{" "}
                    </p>
                    <p>
                      {" "}
                      <strong>Regards </strong>
                      <br />
                      Saiqua Jaffar
                      <br />
                      (SXMUN Advisor)
                    </p>
                    <div class="clr"></div>
                  </article>
                  <div class="clr"></div>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2024-Secretary-General.jpg"
                        alt="St. Xavier’s School Bathinda"
                        class="sxumn_2021_msg img-fluid"
                      />
                    </LazyLoad>
                    <h3>Secretary General's Message</h3>
                    <p>
                      Leo Tolstoy said in "war and peace", <br />
                      ‘If everyone fought for their own convictions there would
                      be no war.’{" "}
                    </p>
                    <p>Greetings everyone,</p>
                    <p>
                      In this day and age we are plagued by the sheer atrocities
                      of war, genocide and violence. In this vicious
                      environment, where the narrative is highly manipulated by
                      half lies, it is important for us to navigate our own
                      truth.{" "}
                    </p>

                    <p>
                      St Xavier's model United Nations was first launched in
                      2017 with the same belief and it continues to empower and
                      foster young minds. This year we have come up with yet
                      another edition of SXMUN with the theme ‘SALVAGE: Embrace,
                      Enhance, Empower.’ Stemming from Late Latin Salvare (‘to
                      make safe, secure, save’) the word ‘SALVAGE’ means to
                      rescue. Comprehensive strategies need to be necessitated
                      to embrace, enhance, and empower the world and we can
                      create a foundation of mutual respect and understanding by
                      coming together to implement these strategies. As the
                      youth of this planet, the task of rescuing our world from
                      the ongoing human disasters falls on our shoulders. There
                      is no better day to start than today. We shall all start
                      by educating ourselves about our current global happenings
                      in order to be a part of the process of making a change.
                      SXMUN serves as the best platform to ensure proper
                      understanding of geopolitical discourse.{" "}
                    </p>

                    <p>
                      Let us all come together to rid ourselves of our
                      prejudices, to debate and discuss issues in a healthy
                      environment and to empower and encourage opinions of
                      all.{" "}
                    </p>

                    <p>
                      In the end, I would like to quote "the handmaid's tale" by
                      Margaret Atwood{" "}
                    </p>
                    <p>
                      "There is more than one kind of freedom...Freedom to and
                      freedom from. In the days of anarchy, it was freedom to.
                      Now you are being given freedom from. Don't underrate
                      it."{" "}
                    </p>
                    <p>
                      <strong> Regards,</strong>
                      <br />
                      Anahad Cheema <br />
                      (Secretary General, SXMUN'24){" "}
                    </p>
                    <div class="clr"></div>
                  </article>
                  <div class="clr"></div>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2024-Director-General.jpg"
                        alt="St. Xavier’s School Bathinda"
                        class="sxumn_2021_msg img-fluid"
                      />
                    </LazyLoad>
                    <h3>Director General's Message</h3>
                    <p>
                      ‘Coming together is a beginning. Keeping together is
                      progress. Working together is success.’ <br />
                      &nbsp;— Henry Ford.
                    </p>
                    <p>Greetings everyone,</p>
                    <p>
                      Welcome to this year's St. Xavier's Model United Nations
                      conference, where we convene under the theme of ‘SALVAGE:
                      EMBRACE, ENHANCE, EMPOWER.’ This theme speaks to the
                      pressing challenges we face on a global scale today. As
                      the famous African proverb states, "If you want to go
                      fast, go alone. If you want to go far, go together." This
                      year's theme emphasizes the importance of collaboration
                      and unity in striving towards a better world.{" "}
                    </p>
                    <p>
                      We have to accept the complexities of our world with
                      daring hearts - the diverse perspectives, urgent issues
                      and multitude of voices seeking to be heard and the need
                      of the hour is to embrace innovative solutions and bold
                      ideas in our discussions that can lead to meaningful
                      change.{" "}
                    </p>
                    <p>
                      To enhance is to strive for excellence in diplomacy,
                      advocacy, and negotiation, improving upon the status quo.
                      As delegates, you have the power to enhance dialogue,
                      cooperation between nations and our collective ability to
                      address global challenges.{" "}
                    </p>
                    <p>
                      To empower is the cornerstone of our mission. It is about
                      amplifying the voices of the marginalized ensuring that
                      every perspective is valued and empowering every delegate
                      to make a difference. Through your debates and
                      resolutions, you will empower yourselves and others to
                      take action and shape a more sustainable and inclusive
                      future.{" "}
                    </p>
                    <p>
                      Throughout this conference, let us remember the
                      interconnectedness of our actions and the potential we
                      have to salvage what is on the verge of destruction and
                      ruin, embrace what is new, enhance what exists and empower
                      those in need. Together, we can make a profound
                      impact.{" "}
                    </p>
                    <p>
                      Always remember, while making a change is important, it is
                      equally crucial to take that first step towards change and
                      embody the change we wish to see in the world.{" "}
                    </p>
                    <p>
                      <strong>Regards </strong>
                      <br />
                      Sukriti Mittal <br />
                      Director General
                    </p>
                    <div class="clr"></div>
                  </article>
                  <div class="clr"></div>
                </div>
              </div>

              <div className="sxmun_img_sec_new row">
                <center>
                  <h2>Committees and Agendas for SXMUN 2024 </h2>
                </center>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN24-1.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN24-2.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN24-3.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN24-4.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN24-5.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN24-6.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4 mx-auto d-block">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN24-7.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
              </div>

              <div className="col-lg-12 col-md-12 col-sm-12 col-12 sx_msg_sec">
                <center>
                  <h2>THE SECRETARIAT</h2>
                </center>
                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Anahad-24.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>

                  <p> Maya Angelou wrote in 'On the Pulse of the Morning' – </p>
                  <p>
                    {" "}
                    "But today, the Rock cries out to us, clearly,
                    forcefully,{" "}
                  </p>
                  <p> Come, you may stand upon my </p>
                  <p> Back and face your distant destiny." </p>

                  <p>
                    My heartfelt greetings and welcome to all to SXMUN24, the
                    eighth edition. The theme, "SALVAGE: Embrace, Enhance,
                    Empower" stems from the Latin word 'salvare' meaning 'to
                    rescue'. In this day and age where the political narrative
                    is profoundly marred by communal ideologies, it is crucial
                    to rescue ourselves and others from this intellectual
                    genocide, which our theme encapsulates perfectly. It is our
                    destiny to salvage this earth by embracing, enhancing and
                    empowering the planet and its residents. Ever since its
                    conception in 2017, SXMUN has been serving this very purpose
                    by educating young minds and empowering their thoughts. I,
                    myself, started my MUN journey with SXMUN20 where I won high
                    commendation. From then on, there was no looking back. I
                    went on to win several trophies and also served as the head
                    of delegate affairs in SXMUN23. SXMUN is the result of our
                    strenuous efforts. I, thus, welcome all to join the St.
                    Xavier's family in their global geopolitical discourse.
                  </p>

                  <p>
                    Anahad Kaur <br />
                    (Secretary General){" "}
                  </p>
                  <div className="clr"></div>
                </article>
                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Sukriti-24.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>
                  <p>
                    “What lies behind us and what lies before us are tiny
                    matters compared to what lies within us.” - Ralph Waldo
                    Emerson{" "}
                  </p>
                  <p>
                    F-R-E-E-D-O-M, a powerful seven-letter word that forms the
                    very core of my existence. Lucius Seneca once wisely stated,
                    “He who is brave is free.” I was not born brave, but rather
                    with a quiet demeanour. However, SXMUN provided me with a
                    platform to showcase my courage and break free from my
                    shell.{" "}
                  </p>
                  <p>
                    Attending my first MUN conference was truly a pivotal moment
                    in my life as it marked the beginning of my journey towards
                    freedom. As an aspiring lawyer (I already argue like one, it
                    is just in a few years' time I will be getting paid for
                    it!), MUN conferences have helped me develop skills in
                    diplomacy, strategic planning, and much more.{" "}
                  </p>
                  <p>
                    Aside from my legal aspirations, I am an avid reader and
                    have a deep passion for watching movies and shows,
                    particularly classics. Reflecting on my journey, I never
                    imagined that I would one day hold the esteemed position of
                    Director General at SXMUN. However, upon contemplation, I
                    realized that it was my destiny all along. MUN conferences
                    are not just about debates; they are about LEARNING- to
                    negotiate, interact, and most importantly, to be BRAVE.{" "}
                  </p>
                  <p>
                    Let us come together at SXMUN’24 to become the best versions
                    of ourselves. And embrace the opportunity to learn, grow,
                    and exhibit our bravery.{" "}
                  </p>

                  <p>
                    Sukriti Mittal <br />
                    (Director General)
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Jotsaroop-24.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>
                  <p> Green day wrote in their song 'Holiday' </p>
                  <p>
                    {" "}
                    "I beg to dream and differ from the hollow lies, this is the
                    dawning of the rest of our lives"{" "}
                  </p>
                  <p>
                    {" "}
                    I am Jotsaroop Kaur Bhasin, the Convener for SXMUN24 and it
                    is both a privilege and an honour to be a part of the St.
                    Xavier's Model United Nations Conference. My relationship
                    with my alma mater runs very deep. I served as the Head Girl
                    in the year 2023-24 and was a part of the USG for SXMUN23
                    where I learned hard work and dedication towards this
                    institution. This motivated me to explore horizons of my own
                    and led me to take part in the moot court competition
                    conducted by the Solaris SDG summit. As I moved forward I
                    explored more opportunities by organising and hosting the
                    St. Xavier's Youth Parliament as the Director General and
                    serving as the Convener in Valour MUN, an initiative taken
                    by a handful of Xavierites. St. Xavier's School educated and
                    gave me the opportunity to widen my horizons. Thus, I
                    welcome you all to SXMUN where healthy arguments are
                    encouraged and positive dialogues promoted.{" "}
                  </p>

                  <p>
                    Jotsaroop Kaur Bhasin <br />
                    (Convener)
                  </p>
                  <div className="clr"></div>
                </article>
                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Vishav-24.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>
                  <p>
                    {" "}
                    "Empower the present, and enhance the future - for in
                    embracing our scars, we forge our strength."{" "}
                  </p>
                  <p>
                    {" "}
                    This quote encapsulates the essence of our conference theme:
                    "Salvage: Embrace, Empower, Enhance."{" "}
                  </p>
                  <p>
                    {" "}
                    I am Vishav Deep Bansal, currently in Grade 10 at St.
                    Xavier's School Bathinda, and I am honoured to serve as the
                    Co-Convenor for SXMUN 2024. My journey in Model United
                    Nations began with SXMUN and it has since led me to
                    participate in over 10 conferences, earning various awards
                    along the way.{" "}
                  </p>
                  <p>
                    {" "}
                    Diplomacy, I believe, is a powerful tool that fosters
                    self-confidence and effective communication. Through my
                    experiences, I have developed a deep understanding of global
                    issues and diplomatic practices. I am committed to enhancing
                    my skills and believe that this conference will provide
                    delegates with invaluable opportunities to grow
                    intellectually and develop their oratory and analytical
                    abilities.{" "}
                  </p>
                  <p>
                    {" "}
                    Being a guitarist, I admire the role of listening in both
                    music and diplomacy. "Listen, Learn, and Lead" is a
                    principle that resonates deeply with me. In music, as in
                    MUN, careful listening and analysis are crucial to mastering
                    the craft and leading effectively. The ability to listen
                    attentively, learn from every experience and apply that
                    knowledge is essential for success in any diplomatic
                    endeavour.{" "}
                  </p>
                  <p>
                    {" "}
                    SXMUN offers more than just a platform for public speaking;
                    it is an opportunity to delve into foreign policies,
                    international relations, and current global challenges. It
                    encourages critical thinking and ethical
                    decision-making.{" "}
                  </p>
                  <p>
                    {" "}
                    I warmly welcome all participants to SXMUN 2024, where
                    together we will embrace challenges, empower each other, and
                    enhance our understanding of the world.{" "}
                  </p>
                  <p>
                    Vishav Deep Bansal <br />
                    (Co- Convener)
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Manraj-24.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>
                  <p>Esteemed Delegates & Faculty Advisors,</p>
                  <p>
                    It is with great reverence and prerogative that I invite you
                    to the eighth iteration of St. Xavier's Model United
                    Nations. As the international community continues to
                    encounter encumbrances, it is imperative that we educate,
                    empower, and encourage the youth to take collaborative
                    action.{" "}
                  </p>
                  <p>
                    We at SXMUN, have always made attempts to stimulate such
                    learnings about diplomacy, while also fostering
                    relationships that will be strengthened during committee and
                    maintained for years to come. Delegates will not only devise
                    resolutions and address oppugnant beliefs but also get to
                    work towards ameliorating affairs that plague the
                    cosmopolitan society. Although times are changing, the
                    ethics and pursuits of SXMUN remain unchanged: we are more
                    committed than ever to providing the new generation with a
                    platform for collaboration, negotiation, and individual
                    growth.{" "}
                  </p>
                  <p>
                    After two years of Model UN experience, I feel extremely
                    elated and ecstatically glad to be serving as the Chief of
                    Staff for SXMUN'24. As a former delegate, I have had the
                    privilege of meeting numerous pioneering and pertinacious
                    individuals from around the world, some of whom I still
                    recall from my initial days in committee. The relationships
                    forged, as well as the guidance and growth received from
                    former mentors and conference leaders, are invaluable
                    takeaways from my Model UN journey and for this, I shall be
                    forever grateful.{" "}
                  </p>
                  <p>
                    I also express appreciation for the dedication and passion
                    of delegates, faculty advisors, and staffers who commit
                    their time and effort to our conferences – it is my
                    conviction that people are the heart of Model UN, a notion
                    consistently proven. I am venerated to be working alongside
                    the diligent secretariat, who strive to provide a fulfilling
                    experience for our committed delegates. I look forward to
                    welcoming you all as you arrive on campus.
                  </p>
                  <p>
                    With Immense Gratitude, <br />
                    Manraj Singh Sandhu.
                  </p>
                  <div className="clr"></div>
                </article>
                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Armaan-24.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>
                  <p>
                    I am Armaan Singh, a fervent member of SXMUN 24 Secretariat.
                    With a zeal to explore for international diplomacy I have
                    been an vigorous participant in SXMUN for the last few
                    years. As a curious student, I have always made an effort to
                    involve myself in school activities and sports and
                    participation in such activities has continuously helped me
                    to develop leadership and organizational skills.
                  </p>
                  <p>
                    I am designated as Technical head in SXMUN2024 and with my
                    current role I am passionate to abide by my responsibilities
                    and am sincerely committed to ensure the smooth operations
                    of audio-visual aids and look after the online platforms to
                    assist the delegates. I aim to encourage and guide new SXMUN
                    participants so as to help them realize their potential as
                    future leaders and global citizens. I request all the
                    delegates to put in their best efforts for a fruitful
                    conference ahead.{" "}
                  </p>
                  <p>
                    Armaan Singh <br />
                    (Technical Head)
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Arshpreet-24.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>
                  <p>
                    I Arshpreet Singh, holding a pivotal role as Logistic Head
                    at SXMUN 2024 and currently pursuing my final year of school
                    am well known for my active engagement in all school events.
                    I find myself responsible for organizing the execution of
                    all logistical aspects of the conferences. Having
                    considerable years of experience in MUN, I have an
                    exceptional track record of managing complex events and
                    ensuring operational excellence.
                  </p>
                  <p>
                    I am proficient enough for at making arrangements for the
                    proper scheduling of sessions and always ensure that every
                    aspect of the conference runs without any hindrance. I am
                    indeed elated to receive all the delegates and would
                    certainly see that all the SXMUN guests experience a
                    meaningful discourse.
                  </p>
                  <p>
                    Arshpreet Singh <br />
                    (Logistic Head)
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Allamveer.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>
                  <p>
                    In the capacity of PR Head in SXMUN 2024, I Allamveer Singh
                    have been an energetic force behind the SXMUN’s outreach
                    strategies. I am responsible for managing social media posts
                    and promotional activities thus making certain that SXMUN’s
                    initiatives and conferences receive the attention of all the
                    delegates who are truly interested in meaningful dialogues.
                    I have been playing a pivotal role in fostering strong
                    relationships with delegates.
                  </p>
                  <p>
                    Currently in 11th standard I have been elected as Deputy
                    Prime Minister in my school thus rendered with the privilege
                    to enhance discipline among the students and initiate all
                    positive changes. I look forward to welcome you all in the
                    forthcoming conference.
                  </p>
                  <p>
                    Allamveer Singh <br />
                    (PR Head)
                  </p>

                  <div className="clr"></div>
                </article>
              </div>

              <div className="sxmun_img_sec_new">
                <h2>
                  {" "}
                  Organising Committee <span></span>
                </h2>
                <div className="clr20"></div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6 sxmun_bg_clr">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/oc-24.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="img-fluid"
                    />
                    <h4> OC </h4>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6 sxmun_bg_clr">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/oc1-24.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="img-fluid"
                    />
                    <h4> OC </h4>
                  </div>
                </div>

                <div className="clr20"></div>
                <h2>
                  {" "}
                  Background Guides <span></span>
                </h2>
                <div className="sxmun_sec_pdf">
                  <div className="row">
                    <div className="col-6 col-sm-4 col-md-3 col-lg-3 fullwidth">
                      <article>
                        {" "}
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/UNGA-24.pdf"
                          target="_blank"
                        >
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                            alt="St. Xavier’s School Bathinda"
                            className="img-fluid"
                          />
                          <h4>UNGA</h4>
                        </Link>{" "}
                      </article>
                    </div>
                    <div className="col-6 col-sm-4 col-md-3 col-lg-3 fullwidth">
                      <article>
                        {" "}
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/UNSC.pdf"
                          target="_blank"
                        >
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                            alt="St. Xavier’s School Bathinda"
                            className="img-fluid"
                          />
                          <h4>UNSC</h4>
                        </Link>{" "}
                      </article>
                    </div>
                    <div className="col-6 col-sm-4 col-md-3 col-lg-3 fullwidth">
                      <article>
                        {" "}
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/UNODC.pdf"
                          target="_blank"
                        >
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                            alt="St. Xavier’s School Bathinda"
                            className="img-fluid"
                          />
                          <h4>UNODC</h4>
                        </Link>{" "}
                      </article>
                    </div>
                    <div className="col-6 col-sm-4 col-md-3 col-lg-3 fullwidth">
                      <article>
                        {" "}
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/UNESCO.pdf"
                          target="_blank"
                        >
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                            alt="St. Xavier’s School Bathinda"
                            className="img-fluid"
                          />
                          <h4>UNESCO</h4>
                        </Link>{" "}
                      </article>
                    </div>
                    <div className="col-6 col-sm-4 col-md-3 col-lg-3 fullwidth">
                      <article>
                        {" "}
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/IP.pdf"
                          target="_blank"
                        >
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                            alt="St. Xavier’s School Bathinda"
                            className="img-fluid"
                          />
                          <h4>IP</h4>
                        </Link>{" "}
                      </article>
                    </div>
                    <div className="col-6 col-sm-4 col-md-3 col-lg-3 fullwidth">
                      <article>
                        {" "}
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/INDIRAWARCABINET.pdf"
                          target="_blank"
                        >
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                            alt="St. Xavier’s School Bathinda"
                            className="img-fluid"
                          />
                          <h4> IWC</h4>
                        </Link>{" "}
                      </article>
                    </div>
                    <div className="col-6 col-sm-4 col-md-3 col-lg-3 fullwidth">
                      <article>
                        {" "}
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/AIPPM-24.pdf"
                          target="_blank"
                        >
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                            alt="St. Xavier’s School Bathinda"
                            className="img-fluid"
                          />
                          <h4>AIPPM</h4>
                        </Link>{" "}
                      </article>
                    </div>
                  </div>
                </div>
                <div className="clr20"></div>
              </div>
              <div className="sxmun_img_sec_new row">
                <center>
                  <h2>The Executive Board</h2>
                </center>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/EXECUTIVE-BOARD-1-24.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/EXECUTIVE-BOARD-2-24.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/EXECUTIVE-BOARD-3-24.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/EXECUTIVE-BOARD-4-24.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/EXECUTIVE-BOARD-5-24.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/EXECUTIVE-BOARD-6-24.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4 mx-auto d-block">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/EXECUTIVE-BOARD-7-24.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
              </div>
              <div class="sxmun_img_sec_new row">
                <iframe
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/SXMUN-Newsletter24.pdf#toolbar=0&amp;navpanes=0"
                  width="100%"
                  height="800px"
                ></iframe>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-year23"
              role="tabpanel"
              aria-labelledby="pills-year23-tab"
            >
              <center>
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN-2023-24.png"
                    alt="St. Xavier’s School Bathinda"
                    className="img-fluid"
                    width="800px"
                  />
                </LazyLoad>
              </center>

              <div className="col-12 row">
                <div className="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Amaro-Martins.jpg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg img-fluid"
                      />
                    </LazyLoad>
                    <h3>Rev. Fr. Manager's Message</h3>
                    <p>Dear Delegates</p>
                    <p>‘Strength exists in togetherness.’</p>
                    <p>
                      It gives me immense pleasure to welcome you all to the 7th
                      edition of SXMUN 2023 with the theme ‘Together towards
                      tomorrow’. The journey of SXMUN was envisioned in the year
                      2017 but with the passage of time, it has been receiving
                      overwhelming responses from delegates both from our school
                      as well as other institutions of repute as they recognize
                      the worth of such dialogues on platforms like SXMUN. This
                      conference must not be considered merely as a medium of
                      simulation of The United Nations rather delegates joining
                      this platform must be sensitive about the core issues of
                      the world and they should attend the conference to share
                      and accept the concerns of each other and offer valuable
                      suggestions to resolve matter unanimously.
                    </p>
                    <p>
                      It is vital to bring the rational minds to a common forum
                      so that they engage in talks with mutual understanding. If
                      the youth is offered today, the privilege to focus their
                      attention on critical issues of the globe then one can be
                      optimistic about the plausibility that the world tomorrow
                      can become a more secure place to live.{" "}
                    </p>
                    <p>
                      Hence, I look forward to offer you my unwavering support
                      in making this conference a huge success and I am sure
                      that the delegates will have far-fetched experience.
                    </p>
                    <p>
                      <strong>Wish you all the very best.</strong>
                      <br />
                      Regards
                      <br />
                      Fr. Amaro Martins
                      <br />
                      (Manager){" "}
                    </p>
                    <div className="clr"></div>
                  </article>
                  <div className="clr"></div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2023-principal.JPG"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg img-fluid"
                      />
                    </LazyLoad>
                    <h3>Rev. Fr. Principal's Message</h3>
                    <p>Dear Delegates,</p>
                    <p>
                      As Henry Ford once said, "If everyone is moving forward
                      together, then success takes care of itself." This rightly
                      encapsulates the spirit we bring into the seventh edition
                      of St. Xavier’s Model United Nations, 2023. SXMUN has
                      always had an eventful and enthralling history of
                      deliberating on issues that justify contemporary
                      pertinence and encourage delegates to stimulate
                      negotiations and discussions of the United Nations. The
                      foundation of SXMUN is based on conspicuous attempts to
                      enhance knowledge, draft resolutions for the current
                      working order and shape novel visions for the era of
                      dynamic transformations across the globe.{" "}
                    </p>
                    <p>
                      This edition of the conference will be adorned by the
                      theme – "TOGETHER TOWARDS TOMORROW" which perfectly
                      epitomizes a sense of shared responsibility for the world
                      in which we all live. The world we live in seems to be
                      drifting apart. We are made to believe by the leaders of
                      the world that we live in a progressive society but the
                      stark reality about poverty, hunger ethnic clashes,
                      discrimination and all kinds of human misery still
                      persists. Moreover, factors like climatic change, future
                      security challenges, economic crisis, impact of AI on
                      workforce loom at large. In order to eradicate these
                      issues we need to rise above mediocrity and embrace an
                      audacious vision for the future by uniting individuals
                      from diverse backgrounds, fostering an environment where
                      innovation thrives, and barriers dissolve.{" "}
                    </p>
                    <p>
                      Through strategic partnerships, synergistic collaborations
                      and resource-pooling, "Together Towards Tomorrow" pioneers
                      novel solutions to societal issues, propelling us forward
                      towards unprecedented achievements. It recognizes that no
                      single entity possesses all the answers or solutions to
                      today's pressing issues. By fostering open dialogue
                      between students from diverse backgrounds and leveraging
                      technological advancements, this initiative paves the way
                      towards a brighter future filled with sustainable
                      opportunities for all involved parties.{" "}
                    </p>
                    <p>
                      As people come together under this banner, they exemplify
                      their commitment to shaping an inclusive and prosperous
                      world for the generations to come. By continually working
                      together and looking beyond immediate goals, we can
                      identify opportunities, anticipate challenges, and devise
                      sustainable solutions that will shape a better tomorrow.
                      As we move forward in this journey, let's remember that
                      progress is not an individual pursuit but a collective
                      endeavor, and by coming together, we can truly make a
                      difference in shaping a scintillating tomorrow.
                    </p>
                    <p>
                      Delighted by the response and appreciation that SXMUN has
                      received for its past conferences and with sheer devotion
                      to connecting such brilliant minds, we hope to bring the
                      envisioned change, by presenting to you SXMUN’23, an
                      effort towards seeking answers, a step towards putting
                      forward and voicing your beliefs with conviction and
                      perseverance. The young intellectuals will find a
                      spellbinding and intriguing platform, wherein the leaders
                      of tomorrow partake in the act of making more astute
                      arrangements, permitting them to convey waves of progress
                      by exhibiting their ideas and knowledge in reference to
                      contemporaneous matters that need to be heeded
                      immediately.
                    </p>

                    <p>
                      <strong>
                        With best wishes and a rewarding experience.
                      </strong>
                      <br />
                      Cidloy Furtado <br />
                      (Principal){" "}
                    </p>
                    <div className="clr"></div>
                  </article>
                  <div className="clr"></div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2023-Coordinator.jpg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg img-fluid"
                      />
                    </LazyLoad>
                    <h3>Coordinator's Message (SXMUN'23)</h3>
                    <p>Dear Delegates</p>
                    <p>
                      “The best preparation for tomorrow is doing your best
                      today.”
                      <br />
                       — H. Jackson Brown, Jr.
                    </p>
                    <p>
                      I am indeed ecstatic to extend my warm invitation to all
                      of you to join the 7th edition of SXMUN 2023 Conference on
                      the 18th and 19th of August, 2023.{" "}
                    </p>
                    <p>
                      The theme of the Colloquium ‘Together Towards Tomorrow’ is
                      an absolute priority for the young intellectuals to ponder
                      upon. Today we stand witnessing catastrophic consequences
                      that have erupted due to rapacious strategy , extreme
                      corruption, war, poverty, callousness, environmental
                      degradation, terrorism, atrocities on women and innocent
                      children . The touch of humanity has shoddily taken a back
                      seat and lust for materialism in this self centered world
                      has blinded the human race that does not pay heed to
                      critical issues. Thus, the situation around the globe is
                      very grim.
                    </p>
                    <p>
                      Hence, discourses on such serious issues on platforms like
                      SXMUN renders the privilege to the young minds to
                      collaborate together and promote the steps to rectify the
                      heinous errors that are being committed in the society so
                      that the possibility of amendments leaves an optimistic
                      note for the world.{" "}
                    </p>
                    <p>
                      SXMUN 2023 is once again coming up with exigent agendas
                      that require immediate attention and cogitation on such
                      agendas will certainly lead to chipping in of ideas that
                      can be implemented to eliminate the predicaments the world
                      is facing today.
                    </p>

                    <p>
                      <strong>
                        I extend my best wishes to all of you and look forward
                        to a prolific dialogue ahead.
                      </strong>
                      <br />
                      Regards
                      <br />
                      Saiqua Jaffar
                      <br />
                      (MUN Coordinator)
                    </p>
                    <div className="clr"></div>
                  </article>
                  <div className="clr"></div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2023-Advisor.jpg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg img-fluid"
                      />
                    </LazyLoad>
                    <h3>Advisor's Message (SXMUN'23)</h3>
                    <p>
                      Greetings Delegates
                      <br />
                      <br />
                      “Each of us can make a difference. Together we make
                      change.” – Barbara Mikulski
                      <br />
                      SXMUN in its maiden attempt in 2017 unlocked a significant
                      platform for the intellectual delegates to brace
                      acquaintances, anticipate dreams, learn diplomacy and
                      negotiate skills through research and deliberations.
                      <br />I am elated to receive all the delegates for our
                      next episode of SXMUN 2023 which has already set the stage
                      for fiery dialogues on critical agendas that require
                      instantaneous attention of people who are sensitive
                      towards these problems.
                      <br />
                      SXMUN is not merely a trivial or an entertaining event
                      rather every individual who volunteers to participate in
                      this event need to have an insightful approach towards all
                      the agendas that are deliberated on this platform and
                      introspect on the vices and follies of mankind so that we
                      can all come together to work in solidarity to rectify the
                      mistakes of the past before it is too late.
                      <br />I believe that your imaginative, cognitive and
                      enterprising minds together with your un daunting
                      determination will definitely set an example to live up to
                      the expectation of the theme ‘Together Towards Tomorrow.’
                    </p>

                    <p>
                      <strong>Wish you all the best. God bless all.</strong>
                      <br />
                      Regards
                      <br />
                      Poonam Baghla
                      <br />
                      (MUN Advisor)
                    </p>
                    <div className="clr"></div>
                  </article>
                  <div className="clr"></div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2023-Secretary-General.jpg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg img-fluid"
                      />
                    </LazyLoad>
                    <h3>Secretary General's Message</h3>

                    <p>
                      Dear delegates of SXMUN'23,
                      <br />
                      <br />
                      It is with immense pleasure and anticipation that I
                      welcome each one of you to this year's conference with the
                      theme "Together Towards Tomorrow." In our interconnected
                      world, the need for collaboration and unity has never been
                      more critical.
                      <br />
                      Over the next few days, you will engage in meaningful
                      discussions, negotiations, and problem-solving. As
                      delegates representing diverse nations and perspectives,
                      your ideas and actions hold the potential to shape a
                      better future for all.
                      <br />
                      Remember, it is not just about winning debates or passing
                      resolutions; it is about finding common ground,
                      understanding different viewpoints, and forging alliances
                      to tackle pressing global issues. Embrace the spirit of
                      empathy, cooperation, and diplomacy as you work towards
                      building a more sustainable, just, and peaceful world.
                      <br />I am confident that your dedication, creativity, and
                      commitment will pave the way for a brighter tomorrow. Let
                      us embark on this journey together, leaving no one behind,
                      and forging a path towards a more prosperous and
                      harmonious future.
                      <br />
                      Wishing you all fruitful deliberations and an
                      unforgettable experience at SXMUN'23.
                    </p>
                    <p>
                      <strong>Best regards,</strong>
                      <br />
                      Amanat Brar
                      <br />
                      (Secretary General, SXMUN'23){" "}
                    </p>
                    <div className="clr"></div>
                  </article>
                  <div className="clr"></div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2023-Director-General.JPG"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg img-fluid"
                      />
                    </LazyLoad>
                    <h3>Director General's Message</h3>
                    <p>
                      "Alone we can do so little; together we can do so much", -
                      rightly quoted by Helen Keller, describes my utmost honour
                      and enthusiasm to invite you all to this seventh edition
                      of the St. Xavier's Model United Nations.
                      <br />
                      I am absolutely thrilled about the prospect of "Together
                      Towards Tomorrow"! This initiative holds immense promise
                      as it signifies a collective effort towards creating a
                      brighter future. It brings togetherness and unity to the
                      forefront, emphasizing that only by working hand in hand
                      can we overcome the challenges ahead. The excitement lies
                      in the endless possibilities this collaboration could
                      bring - innovative solutions to pressing global issues,
                      groundbreaking discoveries, and transformative
                      advancements in various fields. The phrase itself evokes
                      an uplifting sensation, fuelling our anticipation for what
                      lies ahead. It encourages us to embrace change, envision a
                      better tomorrow, and actively contribute towards its
                      realization. With "Together Towards Tomorrow," hope
                      abounds, inspiring individuals from different backgrounds
                      to come together and pave the way for a prosperous and
                      sustainable future. This rallying cry ignites passion
                      within us all–a shared determination to create positive
                      change on both individual and collective levels.
                      <br />
                      It champions collaboration, innovation, and unwavering
                      determination to tackle the pressing challenges of our
                      time. By bringing together brilliant minds and inspiring
                      leaders, Together Towards Tomorrow sparks unprecedented
                      dialogues and generates transformative solutions that set
                      new standards for excellence. This audacious endeavour
                      holds nothing back in its quest for meaningful change on a
                      global scale, undeterred by obstacles or naysayers. Guided
                      by a relentless belief in humanity's potential, the theme
                      propels us towards an era of achievement where boundaries
                      are shattered, limits are surpassed, and dreams become
                      reality. Brace yourself for an extraordinary journey that
                      will leave an indelible mark on history – because tomorrow
                      begins now!
                      <br />
                      I’d like to take this opportunity to invite everyone in
                      the two days of discussions, deliberations, and
                      exhilarating debates. The team has been working tirelessly
                      to bring SXMUN'23 to a reality, and I hope that this
                      iteration is one that leaves a permanent imprint on
                      everyone’s minds. Join us as we change the norms and the
                      world around us, one speech at a time.
                    </p>

                    <p>
                      <strong>With Warm Regards, </strong>
                      <br />
                      Deepika Bansal. <br />
                      (Director General){" "}
                    </p>
                    <div className="clr"></div>
                  </article>
                  <div className="clr"></div>
                </div>
              </div>
              <div className="sxmun_img_sec_new row">
                <center>
                  <h2>Committees and Agendas for SXMUN 2023 </h2>
                </center>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN23-1.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN23-2.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN23-3.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN23-4.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN23-5.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 col-12 sx_msg_sec">
                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN23-1.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>
                  <p>
                    <strong>ILO</strong>
                  </p>
                  <p>
                    The only tripartite U.N. agency, since 1919 the ILO brings
                    together governments, employers and workers of 187 Member
                    States, to set labour standards, develop policies and devise
                    programmes promoting decent work for all women and men. The
                    main aims of the ILO are to promote rights at work,
                    encourage decent employment opportunities, enhance social
                    protection and strengthen dialogue on work- related issues.
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN23-2.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>
                  <p>
                    <strong>FSC</strong>
                  </p>
                  <p>
                    We introduce you to our first futuristic committee: the
                    Security Council! If you are a visionary person, thinking
                    and imagining how the future will look like and if you have
                    the notions to mould the world into a congenial place, then
                    this is the perfect fit for you! Apply now as a delegate to
                    our futuristic UN Security Council!
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN23-3.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>
                  <p>
                    <strong>UNCSW</strong>
                  </p>
                  <p>
                    The United Nations Commission on the Status of Women (UNCSW)
                    is the principal global intergovernmental body exclusively
                    dedicated to the promotion of gender equality and the
                    empowerment of women. The UNCSW is instrumental in promoting
                    women’s rights, documenting the reality of women's lives
                    throughout the world, and shaping global standards on gender
                    equality and the empowerment of women.
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN23-4.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>
                  <p>
                    <strong>WB</strong>
                  </p>
                  <p>
                    With 189 member countries, staff from more than 170
                    countries, and offices in over 130 locations, the World Bank
                    Group is a unique global partnership: five institutions
                    working for sustainable solutions that reduce poverty and
                    build shared prosperity in developing countries.
                  </p>

                  <div className="clr"></div>
                </article>
                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN23-5.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>
                  <p>
                    <strong>AIPPM</strong>
                  </p>
                  <p>
                    The All India Political Parties Meet is a forum for
                    discussion and deliberation that is called each time before
                    the session of the Parliament commences. Here delegates
                    delve into the nuances and intricacies of modern-day Indian
                    politics with its caveats. With members from both houses of
                    the Parliament present, the AIPPM strives to encourage
                    deliberation on discourses surrounding socio-economic and
                    geopolitical issues.
                  </p>

                  <div className="clr"></div>
                </article>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 col-12 sx_msg_sec">
                <center>
                  <h2>THE SECRETARIAT</h2>
                </center>
                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Amanat-23.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>

                  <p>
                    I am Amanat Brar, a 12th Grader at St. Xavier’s and it is my
                    privilege to serve as the Secretary General of SXMUN this
                    year. As Helen Keller once said, "Alone we can do so little;
                    together we can do so much." This quote perfectly
                    encapsulates the theme of this year's conference, "Together
                    Towards Tomorrow." As the Secretary General, I am committed
                    to fostering a collaborative and inclusive environment where
                    delegates can work together to develop creative solutions to
                    the world's most pressing issues. With my extensive
                    experience in MUN and my passion for global issues, I am
                    confident that we can make a real difference at this
                    conference. I am unequivocally looking forward to an
                    unforgettable experience for everyone at the 7th Edition of
                    St. Xavier’s Model United Nations.
                  </p>
                  <div className="clr"></div>
                </article>
                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Deepika-23.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>

                  <p>
                    A grade 12 student at St. Xavier’s School, Bathinda, I,
                    Deepika Bansal feel beyond ecstatic to be serving as the
                    Director-General for SXMUN'23. Despite being initially
                    apprehensive of stupendous words, hand gestures and daises,
                    I have somehow made it from the back column to the big
                    table. Whether it be the intriguing wrangles during
                    moderated caucuses, the multifarious brain cells lost during
                    the witching hour crises, or the cultured people that I have
                    met along the way, MUNs have incredibly shaped me into who I
                    am today. Reflecting upon my 5 years of implication within
                    the Model UN community, all the hours of onerous composing
                    seem to have been negated by the doting friendships and
                    bounteous nature of this pursuit, but it is such committee
                    experiences, both as a delegate and a USG member, that have
                    ingrained in me a passion for the intricacies of global
                    politics and diplomacy. From fermenting my adulation for
                    world affairs to equipping me with the power of elocution, I
                    have come to treasure both the academically stimulating and
                    socially entertaining facets of an MUN, for which I also
                    feel exceedingly grateful. Whether it is your first
                    conclave, or if you heretofore have a stack of badges and
                    placards at home, whether you will pitch in your first
                    quivering speech or the centennial rebuttal at this
                    colloquium, I am certain that this conference will spark a
                    passion for diplomacy in every envoy that steps into the
                    committee and that it will find its own remarkable place in
                    your heart, whether it be in significant lessons,
                    everlasting memories, or life-long friendships.
                    Consequently, I am unequivocally looking forward to an
                    engaging and unforgettable experience for everyone at the
                    seventh iteration of St. Xavier’s Model United Nations.
                  </p>
                  <div className="clr"></div>
                </article>
                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Yatish-23.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>

                  <p>
                    {" "}
                    Confidence is like an anchor; it helps me to move forward
                    with people and opportunities. Diplomacy is an extension of
                    me at conferences. It's a responsibility. SXMUN has great
                    things happening in it.{" "}
                  </p>
                  <p>A very warm greetings to one and all</p>
                  <p>I am Yatish Chawla, the Convenor of SXMUN 2023.</p>
                  <p>
                    Confidence provides stability and allows us to navigate
                    through various interactions and opportunities. This is what
                    I believe in. Extracurricular activities, management,
                    hosting, and academics , I have delivered my best in each
                    and every manner and improved myself day by day, which
                    helped me to become the General Secretary of my school
                    (2022–23). SXMUN helped me to infuse self-reliance and
                    knowledge and improved my diplomatic skills and personality.
                    The role of SXMUN in my life is immense. I welcome you all
                    to the 7th edition of SXMUN to gather valuable and memorable
                    experiences through which we move together towards tomorrow.
                  </p>
                  <div className="clr"></div>
                </article>
                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Rakshant-23.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>
                  <p>
                    I am Rakshant Singla, who has been recently appointed as the
                    Chief of Staff in SXMUN23. With a strong passion for
                    international relations and diplomacy, I consistently
                    propelled myself to great heights within the MUN committee
                    last year. My dedication and expertise as a delegate earned
                    me recognition as a distinguished member of the Secretariat.
                    Serving as the USG team member MUN has always served me
                    seeking great opportunities to expand my understanding of
                    global affairs. I see the upcoming event full of
                    constructive dialogues, participation and I assure that we
                    would make this event a successful one.
                  </p>
                  <div className="clr"></div>
                </article>
                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Bhavna-23.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>
                  <p>
                    As a technical head of SXMUN'23, I Bhavna find myself
                    inspired to receive you at 7th edition of St. Xavier
                    School's MUN conference. I have always exercised my
                    versatility by actively participating in numerous MUN
                    conferences in the past 4 years. Last year, I served as a
                    USG member, where I demonstrated my exceptional leadership
                    skills and passion for global issues. Today, I am tapped as
                    the Technical Head for school's Model United Nations, a role
                    that will allow me to apply my unparalleled expertise in
                    technology to enhance the conference experience for all
                    participants. My unwavering commitment to MUN has always
                    embraced me with new challenges and continuously pushes
                    boundaries to achieve greatness. Looking forward to embark
                    on this platform with substantial ardour.
                  </p>
                  <div className="clr"></div>
                </article>
                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Ashley-23.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>
                  <p>
                    As Co-convener of the UN Model at St Xaviers Bathinda , I
                    Ashley have had the privilege of spearheading a student-led
                    initiative that aims to promote global awareness and
                    cultivate diplomatic skills. Through this endeavor, I've
                    honed my leadership and communication abilities and have
                    gained a deeper understanding of international relations and
                    the intricacies of diplomacy. I'm passionate about using my
                    skills to make a meaningful impact in the world, and I
                    believe that the UN Model is an effective way to inspire
                    young people to engage with complex global issues and work
                    towards a more equitable and just future. I am certain that
                    this event would be a rewarding one for all of us.
                  </p>
                  <div className="clr"></div>
                </article>
                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Himanshi-23.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>
                  <p>
                    I am Himanshi Gupta and I'm honoured to be serving as the PR
                    Head of the SXMUN 2023. My journey in MUN began as a
                    delegate. Last year, I served as a USG member and this year
                    I have been blessed to be a part of the Secretariat. Since
                    then, I've been passionate about promoting this incredible
                    platform for diplomacy and youth engagement. I've always
                    been fascinated by global affairs and the power of effective
                    communication. 4 years ago, I discovered MUN, which allowed
                    me to combine my interests in international relations and
                    public speaking. Throughout my MUN experience, I realized
                    the critical role that effective PR plays in shaping the
                    image and impact of MUN conferences. Effective PR is not
                    just about publicity; it's about building lasting
                    relationships with our participants, partners, and
                    stakeholders. I'm thrilled to work with the dedicated team
                    at SXMUN to ensure that every conference is a remarkable
                    experience for all involved. Let's make SXMUN conferences,
                    the talk of the town and amplify our voices to make the
                    world a better place, one step at a time!
                  </p>
                  <div className="clr"></div>
                </article>
                <article>
                  <LazyLoad>
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Anahad-23.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="sxumn_2021_msg_secr"
                    />
                  </LazyLoad>
                  <p>
                    It is rightly said, "For good ideas and true innovation, you
                    need human interaction, conflict, argument and debate". I am
                    Anahad Kaur, the head of the department of delegate affairs.
                    St Xavier's has been hosting it's coveted SXMUN since 2017
                    and we are proud to present the 7th edition of SXMUN this
                    year. I have been a part of the St Xavier's family for 13
                    years. I also appeared as a delegate in SXMUN 2020, my first
                    ever experience in an MUN. After securing High Commendation
                    that year, I went on to be the best delegate in The Punjab
                    Vidhan Sabha in Solaris 2022. SXMUN was a stepping stone in
                    my life. It taught me the necessary confidence, the much
                    needed diplomacy that I required in life. It made me
                    cognizant of greater world issues and helped me understand
                    global politics. We at St. Xavier’s believe in inculcating
                    awareness about geopolitical issues at a young age, so that
                    our youth is educated and well informed. SXMUN is a great
                    avenue for international geopolitical discourse. I welcome
                    all to the St. Xavier's family, hoping to uphold our motto
                    to move 'TOGETHER TOWARDS TOMORROW'.
                  </p>
                  <div className="clr"></div>
                </article>
              </div>

              <div className="sxmun_img_sec_new">
                <h2>
                  {" "}
                  Organising Committee <span></span>
                </h2>
                <div className="clr20"></div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6 sxmun_bg_clr">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/USG1-23.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="img-fluid"
                    />
                    <h4> USG </h4>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6 sxmun_bg_clr">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/USG2-23.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="img-fluid"
                    />
                    <h4> USG </h4>
                  </div>
                </div>

                <div className="clr20"></div>
                <h2>
                  {" "}
                  Background Guides <span></span>
                </h2>
                <div className="sxmun_sec_pdf">
                  <div className="row">
                    <div className="col-6 col-sm-4 col-md-3 col-lg-2 fullwidth">
                      <article>
                        {" "}
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/ILO.pdf"
                          target="_blank"
                        >
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                            alt="St. Xavier’s School Bathinda"
                            className="img-fluid"
                          />
                          <h4>ILO</h4>
                        </Link>{" "}
                      </article>
                    </div>
                    <div className="col-6 col-sm-4 col-md-3 col-lg-2 fullwidth">
                      <article>
                        {" "}
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/FSC.pdf"
                          target="_blank"
                        >
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                            alt="St. Xavier’s School Bathinda"
                            className="img-fluid"
                          />
                          <h4>FSC</h4>
                        </Link>{" "}
                      </article>
                    </div>
                    <div className="col-6 col-sm-4 col-md-3 col-lg-2 fullwidth">
                      <article>
                        {" "}
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/UNCSW.pdf"
                          target="_blank"
                        >
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                            alt="St. Xavier’s School Bathinda"
                            className="img-fluid"
                          />
                          <h4>UNCSW</h4>
                        </Link>{" "}
                      </article>
                    </div>
                    <div className="col-6 col-sm-4 col-md-3 col-lg-2 fullwidth">
                      <article>
                        {" "}
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/WB.pdf"
                          target="_blank"
                        >
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                            alt="St. Xavier’s School Bathinda"
                            className="img-fluid"
                          />
                          <h4>WB</h4>
                        </Link>{" "}
                      </article>
                    </div>
                    <div className="col-6 col-sm-4 col-md-3 col-lg-2 fullwidth">
                      <article>
                        {" "}
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/AIPPM-23.pdf"
                          target="_blank"
                        >
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                            alt="St. Xavier’s School Bathinda"
                            className="img-fluid"
                          />
                          <h4>AIPPM</h4>
                        </Link>{" "}
                      </article>
                    </div>
                  </div>
                </div>
                <div className="clr20"></div>
              </div>
              <div className="sxmun_img_sec_new row">
                <center>
                  <h2>The Executive Board</h2>
                </center>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/EXECUTIVE-BOARD-1.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/EXECUTIVE-BOARD-2.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/EXECUTIVE-BOARD-3.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/EXECUTIVE-BOARD-4.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/EXECUTIVE-BOARD-5.jpg"
                    alt="St. Xavier’s School Bathinda"
                  />
                  <div className="clr15"></div>
                </div>
              </div>
              <div class="sxmun_img_sec_new row">
                <iframe
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/SXMUN-Newsletter23.pdf#toolbar=0&amp;navpanes=0"
                  width="100%"
                  height="800px"
                ></iframe>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-home"
              role="tabpanel"
              aria-labelledby="pills-home-tab"
            >
              <div className="col-12 row">
                <center>
                  <LazyLoad>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN-2022-23.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="img-fluid"
                      width="800px"
                    />
                  </LazyLoad>
                </center>
                <div className="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Christopher-Michael.jpg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg img-fluid"
                      />
                    </LazyLoad>
                    <h3>Rev. Fr. Manager's Message</h3>
                    <p>Dear Delegates,</p>
                    <p>
                      “Peace cannot be kept by force; it can only be achieved by
                      understanding." Albert Einstein’s thought provoking words
                      are not just words but are the beacons of light that can
                      guide our astray, thirsting souls into a cosmos imbued
                      with global peace and amity. The world, today, is feuding
                      with belligerence amongst nations and the ever looming
                      menaces of annihilation. Not just bureaucratic
                      contrarieties but ideological discrepancies and aggravated
                      prejudice towards the marginalized communities are growing
                      exponentially.{" "}
                    </p>
                    <p>
                      What we desperately need are citizens who are well versed
                      with the futility of wars and in whose hearts and minds
                      peace finds resonance. The absolute need of the hour is to
                      bring about people to a common colloquium where
                      dissensions can be reconciled through colloquies, dialogue
                      and mutual understanding. We, at SXMUN, have always
                      embraced avenues that would allow young leaders and global
                      citizens to augment their responsibility apropos their
                      nations and towards mankind as a whole by venturing into
                      the, as of yet, less scouted arenas of cosmopolitanism and
                      statecraft. The objective is to proffer unfaltering
                      solutions to world quandaries in an attempt to parley
                      with, negotiate and prepense upon issues of seismic
                      significance.{" "}
                    </p>
                    <p>
                      The conscience of picknies is edified by the ascendancies
                      that encompass them and their notions of good and evil are
                      ensued from the scrupulous ambience they suspire in. Ergo,
                      the world must be conscious about the surfeit of
                      cataclysms persisting everywhere and all the countries
                      need to procure to a consensus in order to engender a
                      sanguine change in the world that would succour humanity.
                      With this thought in mind, I welcome you all to partake in
                      SXMUN’22 and hope that the convocation will provide our
                      dynamic, budding leaders with strategies and ideas to help
                      resolve the strife and enmity plaguing the modern world
                      currently. I extend my best and unfeigned wishes to all
                      the delegates and look forward to impeccable plenaries
                      ahead.
                    </p>
                    <p>
                      <strong>
                        With best regards and a rewarding experience.
                      </strong>
                      <br />
                      Christopher Michael   <br />
                      (Manager){" "}
                    </p>
                    <div className="clr"></div>
                  </article>
                  <div className="clr"></div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2022-principal.jpg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg img-fluid"
                      />
                    </LazyLoad>
                    <h3>Rev. Fr. Principal's Message</h3>
                    <p>Dear Delegates,</p>
                    <p>
                      As wars and conflicts take root in our world the need for
                      Model United Nations has become imperative. As young
                      leaders your passionate voice for change can never go
                      unheard if its voice of conscious done through
                      consensus.{" "}
                    </p>
                    <p>
                      <strong>
                        {" "}
                        We are writing to formally invite you to join us for
                        SXMUN’22 at Bathinda, Punjab.
                      </strong>{" "}
                      SXMUN’22 with its theme ‘Conscious, Consensus, Change’ our
                      6th annual conference, will run 5 highly engaging
                      committees and agendas that will not only ignite your
                      thinking skills but prepare you for real-world
                      perspectives.{" "}
                    </p>
                    <p>
                      Today, the world yearns for a conscious policy makers and
                      enlightened trailblazers who can engage themselves
                      profusely in hauling off mankind out of the imbroglio of
                      raging wars and conflicts, eternal disputes and
                      digressions in order to reconstruct the world on the
                      cornerstones of peaceful dialogue, deference for
                      contrasting opinions and mutual apprehension.{" "}
                    </p>
                    <p>
                      SXMUN with insightful ratiocinates, analysis and
                      scrutinization will inevitably stimulate and train
                      tomorrow’s leaders to navigate a diverse and complex
                      world.
                    </p>
                    <p>
                      I reckon the active participation and engagement of
                      delegates in the conference that shall lend a Midas touch
                      to erudition, scrupulous endeavours, realistic simulations
                      and leave an exhilarating influence on posterity.{" "}
                    </p>
                    <p>
                      <strong>
                        With best wishes and a rewarding experience.
                      </strong>
                      <br />
                      Cidloy Furtado  <br />
                      (Principal){" "}
                    </p>
                    <div className="clr"></div>
                  </article>
                  <div className="clr"></div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2022-Coordinator.jpg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg img-fluid"
                      />
                    </LazyLoad>
                    <h3>Coordinator's Message (SXMUN'22)</h3>
                    <p>Dear Faculty Advisors and Prospective Delegates,</p>
                    <p>
                      Every jiff, the world becomes rife with myriads of
                      tensity, engulfs in escalating animosities, and
                      experiences diplomatic failures which jeopardize the
                      fragile balance of peace in our world. Thereby, to better
                      equip ourselves to navigate these sitches and apprehend
                      the current geo-political problems faced by individuals
                      residing not only in the vicinity, but also in the remote
                      corners of the world, we must learn from the past.
                    </p>
                    <p>
                      In order to edify the juvenile into succouring the
                      populaces efficaciously, while they decipher the truth on
                      disparate global issues and discover the barbarous
                      realities of life, we, at SXMUN, endeavour to fortify a
                      dogmatic thought process in the students as they prepare
                      for the challenges of the future. The main objective is to
                      engender benevolence in every delegate and invigorate them
                      to proselytize and espouse world peace. We envision every
                      participant as being leaders of tomorrow, equipped with a
                      rationale to combat any despotism or brutality in order to
                      lead mankind on a less destructive path. Our venture has
                      always been to make the event more illuminating for the
                      young minds by providing them an opportunity to engage in
                      debating and deliberating over some of the most pressing
                      hitches that afflict our world today. Curated for both,
                      beginners and veteran participants alike, our committee
                      programs shall offer enthralling experiences to all the
                      delegates.{" "}
                    </p>
                    <p>
                      {" "}
                      Unequivocally, our youth is surging a new future for they
                      see the verity of Mahatma Gandhi’s words – “We must become
                      the change we want to see in the world” – even as they
                      obey their heart, pursue their dreams and vanquish their
                      own trail. Their path of hope, fortitude, candour and
                      probity will concoct a world whose ‘golden age’ is not
                      beyond but ahead of us. Hence, it is with immense pride
                      that I invite you to join us for the sixth edition of the
                      St. Xavier’s Model United Nations conference to be held
                      within our picturesque campus in Bathinda.
                    </p>
                    <p>
                      <strong>
                        With best regards and an enriching experience.
                      </strong>
                      <br />
                      Kushalpreet Cheema   <br />
                      (MUN-Coordinator){" "}
                    </p>
                    <div className="clr"></div>
                  </article>
                  <div className="clr"></div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2022-Secretary-General.jpg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg img-fluid"
                      />
                    </LazyLoad>
                    <h3>Secretary General's Message</h3>
                    <p>
                      "With confidence, you have won before you have started",
                      quoted by Marcus Garvey defines the theory of confidence,
                      wisdom, and self-esteem, judging one's intellect during
                      hard times. With strong self-esteem lies the strong
                      commitment and resolutions, we indulge ourselves to shape
                      and divide up with the surfeit of enigma we face in the
                      outside world. With the ongoing and continuous process of
                      facing the paramount crisis of dilemma in the upcoming
                      'new world', we as young generations need to be obliged to
                      stay CONSCIOUS enough to cope with. A change is very
                      imperative as it has the most dramatic impact on our
                      lives. There is no avoiding it because it compels you to
                      reassess how you indulge your survival. It is our power of
                      choice that concedes us to activate positive change in the
                      world, a decision-making consensus can be the most
                      effective tool that would weave the foremost ideas and key
                      concerns with creative solutions inspiring both
                      individuals and future generations too. In a globe of
                      ample quarrels and conflicts, we as young bees need to
                      suck nectar to fulfil the hunger for a prosperous unity
                      among ourselves and stay vigilant. The theme 'CONSCIOUS
                      CONSENSUS CHANGE' aims to bring out a divulged perspective
                      of one's logic and intelligence accentuating a change
                      around the unconscious world. In today's more shock-prone
                      world, the challenges we face are just indivisible, our
                      efforts to solve them must be indivisible as well. Quite
                      fairly, we as subjects of the concerned world together as
                      United Nations requisite to make headway a consensus, so
                      that our broaches and opinions boundaries the root cause
                      of the problem. The threats to our collective prosperity
                      can only be solved by a tested platform that witnesses the
                      presence of global collaboration with the sixth edition of
                      SXMUN that brings forth the opportunity for all growing
                      individuals to be heard with their loud voices and win
                      against the odd. Here, we are with SXMUN'22 to contribute
                      towards debate for the world and to inspire CHANGE.
                      Henceforth, I solemnly provoke a symposium and leap up
                      with confidence by thriving it well, praying for a
                      resilient future.
                    </p>
                    <p>
                      <strong>With Warm Regards, </strong>
                      <br />
                      Diya Asija   <br />
                      (Secretary General){" "}
                    </p>
                    <div className="clr"></div>
                  </article>
                  <div className="clr"></div>
                </div>
                <div className="sxmun_img_sec_new row">
                  <center>
                    <h2> Committees and Agendas for SXMUN 2022</h2>
                  </center>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/1-UNSC.jpg"
                      alt="St. Xavier’s School Bathinda"
                    />
                    <div className="clr15"></div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2-AIPPM.jpg"
                      alt="St. Xavier’s School Bathinda"
                    />
                    <div className="clr15"></div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/3-ECOFIN.jpg"
                      alt="St. Xavier’s School Bathinda"
                    />
                    <div className="clr15"></div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/4-UNODC.jpg"
                      alt="St. Xavier’s School Bathinda"
                    />
                    <div className="clr15"></div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/5-UNEP.jpg"
                      alt="St. Xavier’s School Bathinda"
                    />
                    <div className="clr15"></div>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/1-UNSC.jpg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg_secr"
                      />
                    </LazyLoad>
                    <p>
                      <strong>UNSC</strong>
                    </p>
                    <p>
                      The Security Council has primary responsibility, under the
                      UN Charter, for the maintenance of international peace and
                      security. It has 15 Members (5 permanent and 10
                      non-permanent members). Each Member has one vote. Under
                      the Charter, all Member States are obligated to comply
                      with Council decisions. The Security Council takes the
                      lead in determining the existence of a threat to the peace
                      or act of aggression. It calls upon the parties to a
                      dispute to settle it by peaceful means and recommends
                      methods of adjustment or terms of the settlement. In some
                      cases, the Security Council can resort to imposing
                      sanctions or even authorize the use of force to maintain
                      or restore international peace and security. The Security
                      Council has a Presidency, which rotates, and changes,
                      every month
                    </p>
                    <p>
                      Source:-{" "}
                      <Link
                        target="_blank"
                        to="https://www.un.org/en/about-us/main-bodies"
                      >
                        https://www.un.org/en/about-us/main-bodies
                      </Link>
                    </p>
                    <div className="clr"></div>
                  </article>
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2-AIPPM.jpg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg_secr"
                      />
                    </LazyLoad>
                    <p>
                      <strong>AIPPM</strong>
                    </p>
                    <p>
                      AIPPM provides a platform for delegates to discourse,
                      agree or disagree and finally reach to a consensus on
                      national issues. Delegates represent personalities from
                      different political parties of our country. This Indian
                      committee simulates the real agendas by reproducing
                      various stages of policy and jurisdiction as well as
                      updating us with different issues going on in our country.
                    </p>
                    <p>
                      Source:-{" "}
                      <Link
                        target="_blank"
                        to="http://solmun.nmims.edu/all-india-political-party-meet/"
                      >
                        Source:-http://solmun.nmims.edu/all-india-political-party-meet/
                      </Link>
                    </p>
                    <div className="clr"></div>
                  </article>
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/3-ECOFIN.jpg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg_secr"
                      />
                    </LazyLoad>
                    <p>
                      <strong>ECOFIN</strong>
                    </p>
                    <p>
                      It will deal with issues relating to economic growth and
                      development such as macroeconomic policy questions;
                      financing for development; sustainable development;
                      globalization and interdependence; eradication of poverty;
                      operational activities for development; agriculture
                      development, food security and nutrition; information and
                      communications technologies for development; and towards
                      global partnerships.
                    </p>
                    <p>
                      Source:-{" "}
                      <Link
                        target="_blank"
                        to="https://www.un.org/en/ga/second/"
                      >
                        https://www.un.org/en/ga/second/
                      </Link>
                    </p>
                    <div className="clr"></div>
                  </article>
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/4-UNODC.jpg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg_secr"
                      />
                    </LazyLoad>
                    <p>
                      <strong>UNODC</strong>
                    </p>
                    <p>
                      UNODC’s mission is to contribute to global peace and
                      security, human rights, and development by making the
                      world safer from drugs, crime, corruption, and terrorism.
                      This Strategy for the next five years will equip UNODC to
                      deliver effectively, efficiently and with accountability,
                      elevating our support to the Member States to build just,
                      inclusive and resilient societies that leave no one behind
                    </p>
                    <p>
                      Source:-{" "}
                      <Link target="_blank" to="https://www.unodc.org/">
                        https://www.unodc.org
                      </Link>
                    </p>
                    <div className="clr"></div>
                  </article>
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/5-UNEP.jpg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg_secr"
                      />
                    </LazyLoad>
                    <p>
                      <strong>UNEP</strong>
                    </p>
                    <p>
                      UNEP’s mission is to provide leadership and encourage
                      partnership in caring for the environment by inspiring,
                      informing, and enabling nations and peoples to improve
                      their quality of life without compromising that of future
                      generations.
                    </p>
                    <p>
                      UNEP works on delivering transformational change for
                      people and nature by drilling down on the root causes of
                      the three planetary crises of climate change, nature and
                      biodiversity loss, and pollution and waste. UNEP employs
                      seven interlinked subprogrammes for action: Climate
                      Action, Chemicals and Pollutions Action, Nature Action,
                      Science Policy, Environmental Governance, Finance and
                      Economic Transformations and Digital Transformations.
                    </p>
                    <p>
                      Source:-{" "}
                      <Link target="_blank" to="https://www.unep.org/">
                        https://www.unep.org/
                      </Link>
                    </p>
                    <div className="clr"></div>
                  </article>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <center>
                    <h2>THE SECRETARIAT</h2>
                  </center>
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/1.SECRETARY GENERAL -Diya Asija.jpg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg_secr"
                      />
                    </LazyLoad>
                    <p>
                      <strong>Greetings Delegates! </strong>
                    </p>
                    <p>
                      I, Diya Asija, Secretary General of SXMUN'22, gladly
                      welcome you all to the sixth edition of St. Xavier's Model
                      United Nations 2022. With a desire to acknowledge my keen
                      interest in debates and deliberations, MUN has given me an
                      opportunity to dissertate surfeit of predicaments being
                      faced around the world. Being a contributor in several
                      MUN’s as a delegate and having worked as a journalist in
                      SXMUN'19 has rendered me great assertiveness and
                      experience. I have participated in multiple debate
                      competitions at St. Xavier’s as a passionate speaker as
                      well as an interjector. Moreover, assisting USG members in
                      SXMUN for the last three consecutive years has helped me
                      to garner a lot of perspective for organizing an event. I
                      possess leadership skills and behold my promise to turn
                      this colloquium to be one of the most enriching episode
                      for all the delegates. Looking forward to embark on this
                      platform with substantial ardour.{" "}
                    </p>
                    <div className="clr"></div>
                  </article>
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2.DEPUTY SECRETARY GENERAL-Paawan.jpg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg_secr"
                      />
                    </LazyLoad>
                    <p>
                      <strong>Greetings Everyone!</strong>
                    </p>
                    <p>
                      As Deputy Secretary General of SXMUN 2022, I, Paawan
                      Saroop Kaur Sandhu find myself inspired to have you at the
                      6th edition of the St. Xavier School’s MUN
                      conference.{" "}
                    </p>
                    <p>
                      MUN has trained me how to stand up for myself and respect
                      the opinions of one another. This platform instilled in me
                      the confidence to partake in various activities and to
                      contest in our school elections(2021-22) which finally
                      opened the door for me to be elected as the Speaker of our
                      school Parliament. Such thoughtful deliberations have
                      fostered in me the willpower to express myself without any
                      hesitation. My MUN’s experience till date have been
                      entirely engaging and unforgettable. With my curiosity of
                      learning more, I am sure that SXMUN 22 with substantial
                      agendas would be a great platform not only for me but also
                      for all those who are going to be a part of it.{" "}
                    </p>
                    <div className="clr"></div>
                  </article>
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/3.DIRECTOR GENERAL-Deepika.jpg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg_secr"
                      />
                    </LazyLoad>
                    <p>
                      A grade 11 student at St. Xavier’s School, Bathinda, I,
                      Deepika Bansal feel beyond ecstatic to be serving as the
                      Director-General for SXMUN'22. Despite being initially
                      apprehensive of stupendous words, hand gestures and
                      daises, I have somehow made it from the back column to the
                      big table. Whether it is the intriguing wrangles during
                      moderated caucuses, the multifarious brain cells lost
                      during the witching hour crises, or the cultured people
                      that I have met along the way, MUNs have incredibly shaped
                      me into who I am today. Reflecting upon my 4 years of
                      implication within the Model UN community, all the hours
                      of onerous composing seem to have been negated by the
                      doting friendships and bounteous nature of this pursuit,
                      but it is such committee experiences, both as a delegate
                      and a USG member, that have ingrained in me a passion for
                      the intricacies of global politics and diplomacy. From
                      fermenting my adulation for world affairs to equipping me
                      with the power of elocution, I have come to treasure both
                      the academically stimulating and socially entertaining
                      facets of an MUN, for which I also feel exceedingly
                      grateful. Whether it is your first conclave, or if you
                      heretofore have a stack of badges and placards at home,
                      whether you will pitch in your first quivering speech or
                      the centennial rebuttal at this colloquium, I am certain
                      that this conference will spark a passion for diplomacy in
                      every envoy that steps into the committee and that it will
                      find its own remarkable place in your heart, whether it be
                      in significant lessons, everlasting memories, or life-long
                      friendships. Consequently, I am unequivocally looking
                      forward to an engaging and unforgettable experience for
                      everyone at the sixth iteration of St. Xavier’s Model
                      United Nations.
                    </p>
                    <div className="clr"></div>
                  </article>
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/4.DEPUTY DIRECTOR GENERALRadhika.jpg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg_secr"
                      />
                    </LazyLoad>
                    <p>
                      <strong>Greetings Delegates!</strong>
                    </p>
                    <p>
                      I am Radhika who earned the privilege of serving my school
                      as the Environment Minister followed by being designated
                      as the Deputy Speaker of the School Parliament. Besides
                      being fierce enough to stand up for what I truly believe
                      in and warm enough to lend out a helping hand to others, I
                      also possess oratory skills and volunteer often to
                      verbalize my views with an indomitable spirit for the
                      justified cause. I have participated as a delegate in MUN
                      and also have a high-quality experience of working as a
                      USG member. Presently elected as the Deputy Director
                      General, I am acquiring a lot more knowledge and
                      accumulating wider information about major national and
                      international agendas by indulging myself in researching
                      facts on global issues. With a zeal and thirst for
                      exploring and learning more, I am convinced that SXMUN
                      2022 would be a rewarding event for all of us.
                    </p>
                    <div className="clr"></div>
                  </article>
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/5.CONVENER-Vanshika.jpg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg_secr"
                      />
                    </LazyLoad>
                    <p>
                      “Every new experience brings its own maturity and a
                      greater clarity of vision"
                    </p>
                    <p>A very warm greeting to all </p>
                    <p>I am Vanshika Setia, the Convener for SXMUN 2022.</p>
                    <p>
                      Positive growth is very important in one's life, and
                      hence, experiencing different things and learning from
                      every mistake is what I believe in and have followed till
                      date. Dancing , singing, acting, hosting, event organizing
                      or academics, I have delivered my contribution in every
                      possible way which in turn has nurtured me day after day
                      and given me space to improvise myself. I was appointed as
                      the 1st Deputy S.I.G Minister of my school and have also
                      extended my best possible support to SXMUN 2021 as a
                      member of USG. My MUN journey commenced in 2019 and during
                      this journey, I assimilated innumerable valuable skills.
                      MUNs have helped me immensely in building my personality,
                      expanding my knowledge, elevating my confidence, and above
                      all, creating a holistic aptitude in myself. I hope the
                      6th Edition of SXMUN gives us a valuable and memorable
                      experience to cherish and learn from and help us shape a
                      better tomorrow.{" "}
                    </p>
                    <div className="clr"></div>
                  </article>
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/6.CHIEF OF STAFF-Amanat.jpg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg_secr"
                      />
                    </LazyLoad>
                    <p>
                      ‘Life is a journey, with problems to solve, lessons to
                      learn, but most of all, experiences to enjoy.’
                    </p>
                    <p>
                      I, Amanat Brar, currently serving as the Prime Minister of
                      St. Xavier’s School, Bathinda and elected as the Chief of
                      Staff for SXMUN 2022, feel fortunate enough to extend my
                      greetings to all of you and pleasurably welcome you to the
                      6th edition of SXMUN. SXMUN, since its very beginning ,
                      has grown to set a benchmark of quality and widespread
                      recognition. Personally, I have always aspired to become a
                      part of the Organizing Committee of this amazing and
                      zealous event. Having attended a number of MUN’s, I have
                      developed a rational thinking towards the issues being
                      faced by the world today. These conferences have helped me
                      boost my confidence over the years, and have also inspired
                      me to find a solution to every problem I come across. I
                      look forward to seeing the upcoming convention full of
                      constructive dialogues and I assure that we would make
                      this event a successful and memorable one.{" "}
                    </p>
                    <div className="clr"></div>
                  </article>
                </div>
                <div className="sxmun_2022_ex_brd row">
                  <center>
                    <h2> THE EXECUTIVE BOARD</h2>
                  </center>
                  <div className="col-xxl-2 col-xl-3 col-lg-6 col-6">
                    <article>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/1.Jashan Gulani.jpg"
                        alt="St. Xavier’s School Bathinda"
                      />
                      <h5>Jashan Guliani</h5>
                      <h3>AIPPM</h3>
                      <div className="clr15"></div>
                    </article>
                  </div>
                  <div className="col-xxl-2 col-xl-3 col-lg-6 col-6">
                    <article>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2.Chetanya Singla.jpg"
                        alt="St. Xavier’s School Bathinda"
                      />
                      <h5>Chetanya Singla</h5>
                      <h3>AIPPM</h3>
                      <div className="clr15"></div>
                    </article>
                  </div>
                  <div className="col-xxl-2 col-xl-3 col-lg-6 col-6">
                    <article>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/1.Ayush Arora.jpg"
                        alt="St. Xavier’s School Bathinda"
                      />
                      <h5>Ayush Arora</h5>
                      <h3>ECOFIN</h3>
                      <div className="clr15"></div>
                    </article>
                  </div>
                  <div className="col-xxl-2 col-xl-3 col-lg-6 col-6">
                    <article>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2.Sanjana Singla.jpg"
                        alt="St. Xavier’s School Bathinda"
                      />
                      <h5>Sanjana Singla</h5>
                      <h3>ECOFIN</h3>
                      <div className="clr15"></div>
                    </article>
                  </div>
                  <div className="col-xxl-2 col-xl-3 col-lg-6 col-6">
                    <article>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/1.Chirag Kundra.jpg"
                        alt="St. Xavier’s School Bathinda"
                      />
                      <h5>Chirag Kundra</h5>
                      <h3>UNEP</h3>
                      <div className="clr15"></div>
                    </article>
                  </div>
                  <div className="col-xxl-2 col-xl-3 col-lg-6 col-6">
                    <article>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2.Shravan Maheshwari.jpg"
                        alt="St. Xavier’s School Bathinda"
                      />
                      <h5>Shravan Maheshwari</h5>
                      <h3>UNEP</h3>
                      <div className="clr15"></div>
                    </article>
                  </div>
                  <div className="col-xxl-2 col-xl-3 col-lg-6 col-6">
                    <article>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/1.Rashmi Kayat.jpg"
                        alt="St. Xavier’s School Bathinda"
                      />
                      <h5>Rashmi Kayat</h5>
                      <h3>UNODC</h3>
                      <div className="clr15"></div>
                    </article>
                  </div>
                  <div className="col-xxl-2 col-xl-3 col-lg-6 col-6">
                    <article>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2.Ramnique Sandhu.jpg"
                        alt="St. Xavier’s School Bathinda"
                      />
                      <h5>Ramnique Sandhu</h5>
                      <h3>UNODC</h3>
                      <div className="clr15"></div>
                    </article>
                  </div>
                  <div className="col-xxl-2 col-xl-3 col-lg-6 col-6">
                    <article>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/1.Mokshit Sood.jpg"
                        alt="St. Xavier’s School Bathinda"
                      />
                      <h5>Mokshit Sood</h5>
                      <h3>UNSC</h3>
                      <div className="clr15"></div>
                    </article>
                  </div>
                  <div className="col-xxl-2 col-xl-3 col-lg-6 col-6">
                    <article>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2.Udaybir singh sidhu.jpg"
                        alt="St. Xavier’s School Bathinda"
                      />
                      <h5>Udaybir singh sidhu</h5>
                      <h3>UNSC</h3>
                      <div className="clr15"></div>
                    </article>
                  </div>
                  <div className="clr20"></div>
                </div>
                <div className="sxmun_img_sec_new row">
                  <iframe
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/SXMUN-Newsletter.pdf#toolbar=0&navpanes=0"
                    width="100%"
                    height="800px"
                  ></iframe>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-profile"
              role="tabpanel"
              aria-labelledby="pills-profile-tab"
            >
              <div className="col-12 row">
                <center>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN-2021-22.jpg"
                    alt="St. Xavier’s School Bathinda"
                    width="800"
                    height="1192"
                    layout="responsive"
                    style={{ width: "800px" }}
                  />
                </center>
                <div className="clr"></div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/Christopher-Michael.jpg"
                        alt="St. Xavier’s School Bathinda"
                        width="282"
                        height="222"
                        layout="responsive"
                        className="sxumn_2021_msg"
                      />
                    </LazyLoad>
                    <h3>Rev. Fr. Manager's Message</h3>
                    <p>
                      Confined, but not broken. These words perfectly describe
                      our world in the present times where after two years of
                      life in lockdown, the world is rising from its slumber,
                      breaking the chains that incarcerated it and unlocking
                      itself. With slow and careful measures, endeavours are
                      being made to return to pre-COVID times, where our
                      physical bonds were as strong as social ones. While we are
                      all counting down the days to return to a world after
                      COVID-19, we need to be aware that parts of our society
                      will remain permanently changed. This is not to say we are
                      facing a full reset. Rather, life after the virus will be
                      altered by dozens of new tweaks and adjustments. Many of
                      these changes will immediately become the new normal, with
                      people adapting quickly to the different ways COVID-19 has
                      impacted their lives.{" "}
                    </p>
                    <p>
                      But with change, there will arise new challenges. Not only
                      do we have to curb and defeat the present virus, but we
                      also need to come together to prevent future catastrophes.
                      The pandemic has shown us the ugly sides of the world in a
                      new perspective. It has given us a new stand on human
                      rights, on health crisis, on world hunger, and most
                      importantly, on mental health. It is our duty as global
                      citizens to join hands and pro-actively address each and
                      every problem the pandemic has shown us and to inhibit
                      them from taking place again. The world needs to be
                      rebuilt with new frameworks, with cross-border dimensions,
                      needing greater and more effective international
                      coordination and cooperation.
                    </p>
                    <p>
                      You are thus invited at SXMUN'21 to be part of the
                      insightful discussions on a host of issues that we are
                      dogged by today, and with the hope of finding ourselves in
                      their midst.
                    </p>
                    <p>
                      Best Wishes
                      <br />
                      Christopher Michael <br />
                      (Manager){" "}
                    </p>
                    <div className="clr"></div>
                  </article>
                  <div className="clr"></div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/principal.jpg"
                        alt="St. Xavier’s School Bathinda"
                        width="282"
                        height="222"
                        layout="responsive"
                        className="sxumn_2021_msg"
                      />
                    </LazyLoad>
                    <h3>Rev. Fr. Principal's Message</h3>
                    <p>
                      <strong>Dear Delegates, </strong>
                    </p>
                    <p>
                      A staunch credence that the ingenious young minds can
                      solely foster the seed of a desired global change streaks
                      across the scholastic firmament of SXMUN.
                    </p>
                    <p>
                      SXMUN’21 with its theme ‘The Awakening Times’ is a utopian
                      platform for young delegates to converge on a common
                      colloquium to amicably synergize their endeavors and
                      convictions, directing them resolutely to scout viable
                      solutions for all the cosmopolitan and environmental
                      hitches that have tormented our planet, enfeebling and
                      debilitating its rapport, serenity and much sought sense
                      of fraternity.
                    </p>
                    <p>
                      Today, the world yearns for a juvenile battalion of agile,
                      equipped, peacenik policy makers and enlightened
                      trailblazers who can engage themselves profusely in
                      hauling off mankind out of the imbroglio of raging
                      conflicts, eternal disputes and digressions in order to
                      reconstruct the world on the cornerstones of peaceful
                      dialogue, deference for contrasting opinions and mutual
                      apprehension. SXMUN with insightful ratiocinates, analysis
                      and scrutinisation will inevitably stimulate intellectual
                      and social milieu for such a young brigade who would be
                      joining hands to steer the globe in the direction of the
                      utopic vision and ideals of the most venerated and fondly
                      remembered world leaders like Mahatma Gandhi, Martin
                      Luther King Junior, Abraham Lincoln and Nelson Mandela who
                      fought the evils ravaging the world with mighty weapons of
                      non-violent means through peaceful discussions,
                      negotiations and debates.
                    </p>
                    <p>
                      I reckon that the active participation and engagement of
                      delegates in the conclave shall lend a Midas touch to
                      erudition, scrupulous endeavors and leave an exhilarating
                      influence on posterity.
                    </p>
                    <p>
                      With best wishes and a rewarding experience.
                      <br />
                      Cidloy Furtado <br />
                      (Principal){" "}
                    </p>
                    <div className="clr"></div>
                  </article>
                  <div className="clr"></div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <h3>Coordinator's Message</h3>
                    <p>
                      <strong>Dear Delegates,</strong>
                    </p>
                    <p>
                      It has been rightly quoted by Alfred Lord Tennyson, “Made
                      weak by time and fate, but strong in will, to strive, to
                      seek, to find, and not to yield.” As the pandemic
                      surrounds the world with its fatal and detrimental
                      consequences, leaving several countries with thousands of
                      people grieving with deteriorating economic, social and
                      environmental standings, people all over the world strive
                      to not let this get the best of them.
                    </p>
                    <p>
                      It is important to keep in mind that the past year and a
                      half has been nothing short of a bewildering
                      thundecol-lg-ap. It resulted in millions of people dying,
                      food and water shortages, and the collapsing of health
                      infrastructures. Several natural & man-made calamities
                      befell the world, leaving various countries in shambles,
                      resulting in the homelessness of millions of people.{" "}
                    </p>
                    <p>
                      Regardless of such cataclysmal events taking place, no
                      country and its people have given up. Every country
                      carries on its quest for answers, withstanding all
                      debacles thrown at them. The world is divided into
                      different territories, yet in times of such impediments,
                      the governments and people of all countries and cultures
                      are coming together to cooperate and find immunity against
                      the virus.
                    </p>
                    <p>
                      SXMUN’21 brings forth this opportunity for all budding
                      individuals, so that this platform becomes the voice of
                      today’s youth. We aim at inspiring and encouraging all
                      students as we understand the need to help them grow into
                      independent minds.
                    </p>
                    <p>
                      With Warm Regards
                      <br />
                      Alka Dhody
                      <br />
                      (MUN Coordinator){" "}
                    </p>
                    <div className="clr"></div>
                  </article>
                  <div className="clr"></div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <h3>Secretary General's Message</h3>
                    <p>
                      <strong>Dear Delegates,</strong>
                    </p>
                    <p>
                      After four successful versions of SXMUN, we now venture
                      towards the second online edition of SXMUN’21. From an
                      insightful and perspicacious concept, it has burgeoned to
                      a memorable and enthralling conference. I am eminently
                      proud of this praxis where students take a step back from
                      the utopian bubble they are brought up in and deliberate
                      over some of the most pressing hitches and problems that
                      are afflicting the world currently.{" "}
                    </p>
                    <p>
                      Today, quite as never before, there's a dire need to
                      fortify our future generations against the cynic and
                      estranging forces that threaten to overpower humanity for
                      their prodigious appetite for power. These past few years
                      have seen the planet becoming more and more dichotomized
                      and the untold anguish caused by the deleterious and
                      antagonistic forces of fundamentalism are wreaking havoc
                      on humanity. Our leaders are blinded by ignorance and
                      avarice and so our only hope for a refulgent future lies
                      in the hands of the bairn and juvenile. Hence,
                      legitimately fostering these young minds into
                      contemplative and benevolent global citizens is pertinent
                      and salient since they can play a conspicuous role in
                      contriving and initiating the modifications that our
                      society so desperately requires.{" "}
                    </p>
                    <p>
                      Shrouded by dark clouds of extremism, unrest and hunger,
                      we as a race are stoushing for mere survival, scraping the
                      bottom for the slightest glimmer of hope but if we fight
                      as one, with all our strength, with all our moral
                      authority, the tenebrous clouds of precariousness will
                      part and the bright light of optimism will light our path
                      towards an ameliorated future. It is thus my honor and
                      pleasure to invite you all to SXMUN, a conference of the
                      likes you might have never witnessed before. On the days
                      of the colloquium the students transcend to the status of
                      world leaders, participating in scintillating
                      deliberation, all the while making memories for a
                      lifetime. St. Xavier’s School, Bathinda has always been
                      enthusiastic in incentivizing young minds to indulge in
                      more than just their curriculums and try to proliferate
                      and dilate their horizons. Thereby, I fervently anticipate
                      these days of enthralling debate and more significantly,
                      of inspiring change.
                    </p>
                    <p>
                      With Warm Regards, <br />
                      Ramnique Sandhu <br />
                      (Secretary General){" "}
                    </p>
                    <div className="clr"></div>
                  </article>
                  <div className="clr"></div>
                </div>
                <div className="sxmun_img_sec_new row">
                  <center>
                    <h2>SXMUN AGENDAS</h2>
                  </center>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/1.jpeg"
                      alt="St. Xavier’s School Bathinda"
                    />
                    <div className="clr15"></div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2.jpeg"
                      alt="St. Xavier’s School Bathinda"
                    />
                    <div className="clr15"></div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/3.jpeg"
                      alt="St. Xavier’s School Bathinda"
                    />
                    <div className="clr15"></div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/4.jpeg"
                      alt="St. Xavier’s School Bathinda"
                    />
                    <div className="clr15"></div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                    {" "}
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/5.jpeg"
                      alt="St. Xavier’s School Bathinda"
                    />
                    <div className="clr15"></div>
                  </div>
                </div>
                <center>
                  <h2>THE SECRETARIAT</h2>
                </center>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 sx_msg_sec">
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/1_RAMNIQUE.jpeg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg_secr"
                      />
                    </LazyLoad>
                    <p>
                      <strong>Greetings Delegates!</strong>
                    </p>
                    <p>
                      I, Ramnique Sandhu, Secretary General of SXMUN' 21, warmly
                      welcome you all to the fifth edition of St. Xavier's Model
                      United Nations. Having served as a USG member in SXMUN'19
                      and the Deputy Secretary General in SXMUN'20, I was able
                      to experience a behind the scenes perspective of running a
                      conference in addition to being a delegate in more than 25
                      MUNs. I have served as the Head Girl of St. Xavier's
                      School, Bathinda for the session 2019 -20 and am presently
                      serving as the Prime Minister of the school for the
                      session 2021-22. I feel extremely elated and ecstatically
                      glad to be an active member of the COVID volunteer group
                      and have been attending virtual IlRS courses during the
                      pandemic as well.
                    </p>
                    <div className="clr"></div>
                  </article>
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2_UDAYBIR.jpeg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg_secr"
                      />
                    </LazyLoad>
                    <p>
                      <strong>Welcome Delegates</strong>
                    </p>
                    <p>
                      I am Udaybir, the Director General of SXMUN 5th Edition. I
                      was a part of the SXMUN 4th Edition Secretariat in the
                      capacity of IT Head I have the efficiency to fix any
                      technical issue and debug any errors within no time.
                      Filled with enthusiasm and optimism, I keep everyone
                      lively and engrossed at all times. I am ever ready and
                      resolute to accomplish my task with precision. MY solemn
                      devotion and commitment towards my duties motivates me to
                      do the best.
                    </p>
                    <div className="clr"></div>
                  </article>
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/3_ISHANI_KALRA.jpeg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg_secr"
                      />
                    </LazyLoad>
                    <p>
                      <strong>Greeting Delegates</strong>
                    </p>
                    <p>
                      I am Ishani Kalra amd I feel greatly privileged to serve
                      as the Convenor in SXMUN. I have been participating in MUN
                      Conferences as a Reporter since 2019 and I have also
                      worked in the last 2 edition of SXMUN. I have been a
                      member of the Editorial Board of the school and I believe
                      in expressing my thoughts candidly. I am completely
                      committed towards my work. I am looking forward to work
                      with full zest and enrgy to make this event a success.
                    </p>
                    <div className="clr"></div>
                  </article>
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/4_ANGEL.jpeg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg_secr"
                      />
                    </LazyLoad>
                    <p>
                      <strong>Welcome all!</strong>
                    </p>
                    <p>
                      I am Angel , designated as the Chief of Staff for SXMUN
                      2021. For me it was certainly an honourable privilege,
                      serving the school in the capacity of Finance Minister in
                      the year 2019 with utmost passion, zeal and earnestness,
                      where in I always gave my best to look after the
                      collection of funds and its implementation for the welfare
                      of school and other fellow mates, keeping in mind the best
                      utilization and disbursement of the same. Apart from the
                      academic pursuits, I keep myself involved with
                      co-curricular activities, which always allows me to make
                      the best use of the creative skills, which I have learnt,
                      from my Activity Mentors since my kindergarten. I was also
                      designated as the PR Head in SXMUN 4th Edition in the year
                      2020 to collaborate with delegates of different countries
                      and committees in the conference. My ability to leave a
                      remarkable impression in any discussion, with my sensible
                      choice of words and effective communication skills,
                      supports me to be a crowd puller, which allows me to have
                      effective, connect with the audience.
                    </p>
                    <div className="clr"></div>
                  </article>
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/5_VANSHIKA_SETIA.jpeg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg_secr"
                      />
                    </LazyLoad>
                    <p>
                      <strong>Good Morning Delegates</strong>
                    </p>
                    <p>
                      I am Vanshika Setia, head of Information Technology:
                      Having worked as the Deputy SIG Minister , I have a
                      flawless skill to work with a calm temperament and fulfil
                      all my responsibilities. I have been a part of the
                      Organising Committee of different MUNs and worked as the
                      head of Marketing -WPMUN, MILENIO . I have also been a
                      part of USG delegate affairs -The Bhartiya Youth Sansad
                      and Magniloquent MUN. I also take pride in stating that I
                      organised on my own -The Bharatiya Yuva Sabha MUN and it
                      was a great success. I am really eager to welcome all the
                      delegates .
                    </p>
                    <div className="clr"></div>
                  </article>
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/6_ANANDI.jpeg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg_secr"
                      />
                    </LazyLoad>
                    <p>
                      <strong>Good Morning Delegates</strong>
                    </p>
                    <p>
                      I am Anandi , the Operational Head and I’ve attended
                      multiple MUN’s as delegates and won awards for Verbal
                      mention and Special mention. I have also worked as the
                      reporter of SXSMUN for the committee ECOSOC. I also served
                      the school as the member of cultural affairs ministry . I
                      have actively participated in competitions and debates and
                      flawlessly given my best . I always look ahead to be a
                      part in extra curricular activities. I have participated
                      in inter school painting competition and made the school
                      proud by winning position and I look forward to make this
                      MUN a commendable and praiseworthy one.
                    </p>
                    <div className="clr"></div>
                  </article>
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/7_NAAFIAH_ALI.jpeg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg_secr"
                      />
                    </LazyLoad>
                    <p>
                      <strong>Greeting Delegates</strong>
                    </p>
                    <p>
                      I am Naafiah Ali , head of Public Relation Department who
                      has worked as the Deputy Social Welfare Minister of the
                      school and I have attended multiple MUNs as a delegate and
                      have gained a considerable knowledge about the kinds of
                      debates and discussion that are a part of MUN. I always
                      look forward to extend my support to my peers. I love to
                      explore ideas to bring out solutions to various problems.
                      I am very excited to make this event take place
                      successfully.
                    </p>
                    <div className="clr"></div>
                  </article>
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/8_DEEPIKA.jpeg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg_secr"
                      />
                    </LazyLoad>
                    <p>
                      <strong>Greeting Delegates</strong>
                    </p>
                    <p>
                      I am Deepika , appointed as Head of USG Registration who
                      was designated to the post of Secretary to Cultural
                      Affairs. I am very enthusiastic to welcome all the
                      delegates to SXMUN 5th Edition I consider myself to be a
                      problem solver and I am ever ready to logically resolve
                      any dilemma. I take pride for my punctuality and I hold
                      the capability of interacting and coordinating with others
                      effectively. I am very keen on making this MUN an
                      exemplary one.
                    </p>
                    <div className="clr"></div>
                  </article>
                  <article>
                    <LazyLoad>
                      {" "}
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/9_RADHIKA.jpeg"
                        alt="St. Xavier’s School Bathinda"
                        className="sxumn_2021_msg_secr"
                      />
                    </LazyLoad>
                    <p>
                      <strong>Welcome Delegates</strong>
                    </p>
                    <p>
                      I am Radhika , Head of USG Feleitation Having served my
                      school as the Environment Minister, I have been presently
                      been designated as the Deputy Speaker of the School
                      Parliament. I have been an active participant in the inter
                      school painting competition and I am extremely sensitivity
                      to the surroundings around myself. Having participated as
                      a delegate in MUN, I am fully acquainted with the kind of
                      debate and discussion of MUN. Partcipation in various MUNs
                      have really sharpened my knowledge about matters
                      pertaining to world issue.
                    </p>
                    <div className="clr"></div>
                  </article>
                  <div className="clr"></div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="pills-contact"
              role="tabpanel"
              aria-labelledby="pills-contact-tab"
            >
              <center>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/SXMUN.jpg"
                  alt="St. Xavier’s School Bathinda"
                  className="img-fluid"
                  style={{ width: "800px" }}
                />
              </center>
              <div className="clr"></div>
              <div className="clr20"></div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <h3>
                  {" "}
                  A MESSAGE FROM THE SECRETARY GENERAL OF THE UNITED NATIONS{" "}
                  <span></span>
                </h3>
                <div className="clr10"></div>
                <center>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/united.png"
                    alt="St. Xavier’s School Bathinda"
                    className="sxmun_img_sec img-fluid"
                  />
                </center>
                <p>
                  Our world faces an unprecedented crisis that is causing
                  widespread human suffering, upending lives, devastating the
                  global economy and risking reversals of hard-won progress
                  towards the Sustainable Development Goals.
                </p>
                <br />
                <p>
                  In these trying times, I welcome the holding of your Model UN
                  activity. Your unwavering commitment to international
                  cooperation is essential for tackling the COVID-19 pandemic –
                  the biggest test our world has faced since the Second World
                  War.
                </p>
                <br />
                <p>
                  We can only defeat the coronavirus if we do so globally. We
                  must recognize that the poorest countries and most vulnerable
                  will be the hardest hit, and that decades of development gains
                  could be reversed. Countries already suffering armed conflict
                  now face further upheaval. And the pandemic is having a
                  disproportionate impact on the world’s women.
                </p>
                <br />
                <p>
                  The United Nations is undertaking a wide-ranging response –
                  calling for a global ceasefire and working to control the
                  pandemic, save lives, mitigate the socio-economic impacts,
                  fight stigma and recover better.
                </p>
                <br />
                <p>
                  We are strongly committed to providing full support to all,
                  guided by our shared values. The world needs your energy, and
                  I draw great hope from seeing your generation mobilize to
                  address the challenges of our time and to build a healthier,
                  more equitable and sustainable future for all.
                </p>
                <br />
                <p>
                  In that spirit of common cause, I wish you a successful Model
                  UN.
                </p>
                <div className="clr20"></div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <h3>
                  {" "}
                  A MESSAGE FROM THE SECRETARIAT - SXMUN'2020 <span></span>
                </h3>
                <div className="clr10"></div>
                <center>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/sxmun_msg.png"
                    alt="St. Xavier’s School Bathinda"
                    width="1215"
                    height="242"
                    layout="responsive"
                    className="sxmun_img_sec"
                  ></img>
                </center>
                <br />
                <p>
                  The UN is marking its 75th anniversary at a time of great
                  disruption for the world, computed by an unprecedented global
                  health crisis with severe economic and social impacts.
                  Although the world faces a serious threat and is pulling out
                  all the stops to withstand the animosity of this novel virus,
                  with the robust and coalesced efforts of us all, we can emerge
                  out even stronger and valorous.
                </p>
                <br />
                <p>
                  The youth of today are the leaders of tomorrow and keeping
                  this in our minds, we present to you our first ever online MUN
                  with the theme U N75 - 'Cradle the World' Our Model UN
                  Conferences aim to dispense a platform for our emerging assets
                  to prosper and germinate into efficacious personalities who
                  can ergo contribute effectively to forge this world into an
                  aesthetic place. SXMUN is a platform that assists the
                  delegates to strengthen acquaintances, envisage dreams, learn
                  diplomacy and negotiating skills, elevate confidence in public
                  meetings and facilitates one to ignite thoughts.{" "}
                </p>
                <br />
                <p>
                  With this fourth edition of SXMUN, we cordially invite those
                  scintillating souls coupled with ingenious minds to cogitate
                  and debate over the contemporary issues and come up with
                  customised panaceas and attempt to bring about an
                  unconventional change.
                </p>
                <br />
                <p>
                  Our Principal, teachers and the secretariat strive towards
                  leaving no stone unturned so that our delegates get the finest
                  of experience combined with opportunities to burgeon
                  knowledge, develop copious competencies and explore more. On
                  behalf of our faculty and in the spirit of the amalgamated
                  efforts of every stakeholder in this event, we wish a fruitful
                  MUN.{" "}
                </p>
                <p>
                  <strong>
                    Regards, <br />
                    The Secretariat{" "}
                  </strong>
                </p>
                <div className="clr20"></div>
              </div>
              <div className="clr20"></div>
              <div className="sxmun_img_sec_new">
                <h3>
                  SXMUN 2020 COMMITTEES AND AGENDAS <span></span>
                </h3>
                <div className="clr20"></div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6 sxmun_bg_clr">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/sxmun_1.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="img-fluid"
                    />
                    <p>
                      Established in 1945 under the Charter of United Nations,
                      the General Assembly occupies a central position as the
                      chief deliberative, policy making and representative organ
                      of the United Nations. Comprised of all 193 Members of the
                      United Nations, it provides a unique forum for
                      multilateral discussion of the full spectrum of
                      international issues covered by the Charter. It also plays
                      a significant role in the process of standard-setting and
                      the codification of international law.
                    </p>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6 sxmun_bg_clr">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/sxmun_2.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="img-fluid"
                    />
                    <p>
                      The World Health Organisation is the directing and
                      coordinating authority on international health within the
                      United Nations system. The objective of WHO is the
                      attainment by all peoples of the highest possible level of
                      health. Health, as defined in the WHO Constitution, is a
                      state of complete physical, mental and social well being
                      and not merely the absence of disease or infirmity.
                      Working with 194 Member States, across six regions, and
                      from more than 150 offices WHO staff are united in a
                      shared commitment to achieve a better health for everyone,
                      everywhere.
                    </p>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6 sxmun_bg_clr">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/sxmun_3.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="img-fluid"
                    />
                    <p>
                      The Economic and Social Council is at the heart of the
                      United Nations system to advance the three dimensions of
                      sustainable development – economic, social and
                      environmental. It is the central platform for fostering
                      debate and innovative thinking, forging consensus on ways
                      forward, and coordinating efforts to achieve
                      internationally agreed goals. It is also responsible for
                      the follow up to major UN conferences and summits. The UN
                      established ECOSOC in 1945 as one of the six main organs
                      of the United Nations.
                    </p>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6 sxmun_bg_clr">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/sxmun_4.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="img-fluid"
                    />
                    <p>
                      The Human Rights council is an inter – governmental body
                      within the United Nations system responsible for
                      strengthening the promotion and protection of human rights
                      around the globe and for addressing situations of human
                      rights violations and make recommendations on them. It has
                      the ability to discuss all thematic human rights issues
                      and situations that require its attention throughout the
                      year. It meets at the UN office at Geneva. The Council is
                      made up of 47 United Nations member states which are
                      elected by the UN General Assembly. The Human Rights
                      Council replaced the former United Nations Commission
                      Human Rights.
                    </p>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6 sxmun_bg_clr">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/sxmun_5.jpg"
                      alt="St. Xavier’s School Bathinda"
                      className="img-fluid"
                    />
                    <p>
                      All India political Parties Meets are normally called
                      before session of parliament and introduction of bill to
                      reach at consensus on decisions of national importance
                      before session. It was initially formed to have
                      unrestricted debate, deliberation and discussion which may
                      not be allowed in parliament due to time restrictions but
                      now it provides better understanding of national issues.{" "}
                      <strong>
                        Credit :{" "}
                        <Link
                          to="https://www.un.org/"
                          target="_blank"
                          style={{ color: "#2496d1" }}
                        >
                          un.org
                        </Link>{" "}
                      </strong>{" "}
                    </p>
                  </div>
                </div>
                <div className="clr20"></div>
                <h3>
                  THE EXECUTIVE BOARD <span></span>
                </h3>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/UNGA.jpg"
                      alt="St. Xavier’s School Bathinda"
                    ></img>{" "}
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/WHO.jpg"
                      alt="St. Xavier’s School Bathinda"
                    ></img>{" "}
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/ECOSOC.jpg"
                      alt="St. Xavier’s School Bathinda"
                    ></img>{" "}
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/UNHRC.jpg"
                      alt="St. Xavier’s School Bathinda"
                    ></img>{" "}
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/AIPPM.jpg"
                      alt="St. Xavier’s School Bathinda"
                    ></img>{" "}
                  </div>
                </div>
                <div className="clr20"></div>
                <h1>
                  THE SECRETARIAT <span></span>
                </h1>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/1_sxmun.jpg"
                      alt="St. Xavier’s School Bathinda"
                    ></img>{" "}
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/2_sxmun.jpg"
                      alt="St. Xavier’s School Bathinda"
                    ></img>{" "}
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/3_sxmun.jpg"
                      alt="St. Xavier’s School Bathinda"
                    ></img>{" "}
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/4_sxmun.jpg"
                      alt="St. Xavier’s School Bathinda"
                    ></img>{" "}
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/5_sxmun.jpg"
                      alt="St. Xavier’s School Bathinda"
                    ></img>{" "}
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/6_sxmun.jpg"
                      alt="St. Xavier’s School Bathinda"
                    ></img>{" "}
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/7_sxmun.jpg"
                      alt="St. Xavier’s School Bathinda"
                    ></img>{" "}
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/8_sxmun.jpg"
                      alt="St. Xavier’s School Bathinda"
                    ></img>{" "}
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/9_sxmun.jpg"
                      alt="St. Xavier’s School Bathinda"
                    ></img>{" "}
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/10_sxmun.jpg"
                      alt="St. Xavier’s School Bathinda"
                    ></img>{" "}
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/11_sxmun.jpg"
                      alt="St. Xavier’s School Bathinda"
                    ></img>{" "}
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/12_sxmun.jpg"
                      alt="St. Xavier’s School Bathinda"
                    ></img>{" "}
                  </div>
                </div>
                <div className="clr20"></div>
                <h3>
                  BACKGROUND GUIDES <span></span>
                </h3>
                <div className="sxmun_sec_pdf">
                  <div className="row">
                    <div className="col-6 col-sm-4 col-md-3 col-lg-2 fullwidth">
                      <article>
                        {" "}
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/UNGA.pdf"
                          target="_blank"
                        >
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                            alt="St. Xavier’s School Bathinda"
                            className="img-fluid"
                          />
                          <h4>UNGA</h4>
                        </Link>{" "}
                      </article>
                    </div>
                    <div className="col-6 col-sm-4 col-md-3 col-lg-2 fullwidth">
                      <article>
                        {" "}
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/WHO.pdf"
                          target="_blank"
                        >
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                            alt="St. Xavier’s School Bathinda"
                            className="img-fluid"
                          />
                          <h4>WHO</h4>
                        </Link>{" "}
                      </article>
                    </div>
                    <div className="col-6 col-sm-4 col-md-3 col-lg-2 fullwidth">
                      <article>
                        {" "}
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/ECOSOC.pdf"
                          target="_blank"
                        >
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                            alt="St. Xavier’s School Bathinda"
                            className="img-fluid"
                          />
                          <h4>ECOSOC</h4>
                        </Link>{" "}
                      </article>
                    </div>
                    <div className="col-6 col-sm-4 col-md-3 col-lg-2 fullwidth">
                      <article>
                        {" "}
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/UNHRC.pdf"
                          target="_blank"
                        >
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                            alt="St. Xavier’s School Bathinda"
                            className="img-fluid"
                          />
                          <h4>UNHRC</h4>
                        </Link>{" "}
                      </article>
                    </div>
                    <div className="col-6 col-sm-4 col-md-3 col-lg-2 fullwidth">
                      <article>
                        {" "}
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/AIPPM.pdf"
                          target="_blank"
                        >
                          {" "}
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                            alt="St. Xavier’s School Bathinda"
                            className="img-fluid"
                          />
                          <h4>AIPPM</h4>
                        </Link>{" "}
                      </article>
                    </div>
                  </div>
                </div>
                <div className="clr20"></div>
                <h3>
                  BACKGROUND GUIDES FROM INTERNATIONAL MODEL UNITED NATIONS
                  ASSOCIATION, NEW YORK<span></span>
                </h3>
                <div className="row">
                  <center>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/sxmun_imuna.jpg"
                      className="img-fluid sxmun-imun"
                      alt="St. Xavier’s School Bathinda"
                    />
                  </center>
                  <div className="sxmun_sec_pdf">
                    <div className="row">
                      <div className="col-6 col-sm-4 col-md-3 col-lg-2 fullwidth">
                        <article>
                          {" "}
                          <Link
                            to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/CRISI-SIGINT.pdf"
                            target="_blank"
                          >
                            {" "}
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                              alt="St. Xavier’s School Bathinda"
                              className="img-fluid"
                            />
                            <h4>CRISIS-SIGINT</h4>
                          </Link>{" "}
                        </article>
                      </div>
                      <div className="col-6 col-sm-4 col-md-3 col-lg-2 fullwidth">
                        <article>
                          {" "}
                          <Link
                            to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/CCPCJ.pdf"
                            target="_blank"
                          >
                            {" "}
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                              alt="St. Xavier’s School Bathinda"
                              className="img-fluid"
                            />
                            <h4>CCPCJ</h4>
                          </Link>{" "}
                        </article>
                      </div>
                      <div className="col-6 col-sm-4 col-md-3 col-lg-2 fullwidth">
                        <article>
                          {" "}
                          <Link
                            to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/IBRD.pdf"
                            target="_blank"
                          >
                            {" "}
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                              alt="St. Xavier’s School Bathinda"
                              className="img-fluid"
                            />
                            <h4>IBRD</h4>
                          </Link>{" "}
                        </article>
                      </div>
                      <div className="col-6 col-sm-4 col-md-3 col-lg-2 fullwidth">
                        <article>
                          {" "}
                          <Link
                            to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/SOCHUM.pdf"
                            target="_blank"
                          >
                            {" "}
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                              alt="St. Xavier’s School Bathinda"
                              className="img-fluid"
                            />
                            <h4>SOCHUM</h4>
                          </Link>{" "}
                        </article>
                      </div>
                      <div className="col-6 col-sm-4 col-md-3 col-lg-2 fullwidth">
                        <article>
                          {" "}
                          <Link
                            to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/pdf/UNESCAP.pdf"
                            target="_blank"
                          >
                            {" "}
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/library.png"
                              alt="St. Xavier’s School Bathinda"
                              className="img-fluid"
                            />
                            <h4>UNESCAP</h4>
                          </Link>{" "}
                        </article>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="memories_sec">
                <div className="row">
                  <div className="col">
                    <h3>WHO</h3>
                  </div>
                  <div className="clearfix"></div>
                  <div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <center>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/who_1.png"
                          alt="St. Xavier School"
                        />
                      </center>
                    </article>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <center>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/who_2.png"
                          alt="St. Xavier School"
                        />
                      </center>
                    </article>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <center>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/who_3.png"
                          alt="St. Xavier School"
                        />
                      </center>
                    </article>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <center>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/who_4.png"
                          alt="St. Xavier School"
                        />
                      </center>
                    </article>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <h3>UNGA</h3>
                  </div>
                  <div className="clearfix"></div>
                  <div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <center>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/unga_1.png"
                          alt="St. Xavier School"
                        />
                      </center>
                    </article>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <center>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/unga_2.png"
                          alt="St. Xavier School"
                        />
                      </center>
                    </article>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <center>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/unga_3.png"
                          alt="St. Xavier School"
                        />
                      </center>
                    </article>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <h3>UNHRC</h3>
                  </div>
                  <div className="clearfix"></div>
                  <div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <center>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/unhrc_1.png"
                          alt="St. Xavier School"
                          className="img-fluid"
                        />
                      </center>
                    </article>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <center>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/unhrc_2.png"
                          alt="St. Xavier School"
                          className="img-fluid"
                        />
                      </center>
                    </article>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <center>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/unhrc_3.png"
                          alt="St. Xavier School"
                          className="img-fluid"
                        />
                      </center>
                    </article>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <center>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/unhrc_4.png"
                          alt="St. Xavier School"
                          className="img-fluid"
                        />
                      </center>
                    </article>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <center>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/unhrc_5.png"
                          alt="St. Xavier School"
                          className="img-fluid"
                        />
                      </center>
                    </article>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <center>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/unhrc_6.png"
                          alt="St. Xavier School"
                          className="img-fluid"
                        />
                      </center>
                    </article>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <center>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/unhrc_7.png"
                          alt="St. Xavier School"
                          className="img-fluid"
                        />
                      </center>
                    </article>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-6 col-6 fullwidth550">
                    <article>
                      <center>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/unhrc_8.png"
                          alt="St. Xavier School"
                          className="img-fluid"
                        />
                      </center>
                    </article>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="clr"></div>
      </div>
      <Footer />
    </>
  );
};

export default SxmunInformation;
